/**
 * ภาษาไทย
 *
 * คีย์มาจาก `cs.js` ถ้าคีย์ไหนขาด จะแสดงข้อความภาษาอังกฤษ (และถ้าไม่มีอีก
 * ก็เป็นภาษาเช็ก) เพื่อให้เห็นช่องว่างได้ชัด
 *
 * คำแปลนี้ยังไม่มีคนข้ามเพศที่พูดภาษาไทยอ่านทบทวน คำศัพท์เรื่องการข้ามเพศ
 * ที่นี่สำคัญกว่าที่อื่น ถ้ามีอะไรฟังดูไม่ถูก บอกเราแล้วเราจะแก้
 */
const th = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'กลับ',
  'obecne.hledat': 'ค้นหา',
  'obecne.nacitani': 'กำลังโหลด…',
  'obecne.zrusit': 'ยกเลิก',
  'obecne.ulozit': 'บันทึก',
  'obecne.odeslat': 'ส่ง',
  'obecne.vice': 'ดูทั้งหมด',
  'obecne.jazyk': 'ภาษา',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'พื้นที่ปลอดภัยสำหรับชุมชนคนข้ามเพศ ที่คุณพูดได้อย่างเปิดใจ หาความช่วยเหลือ และรู้สึกถึงการสนับสนุนจากคนอื่น',
  'auth.prihlaseni': 'เข้าสู่ระบบ',
  'auth.registrace': 'สมัคร',
  'auth.email': 'อีเมล',
  'auth.heslo': 'รหัสผ่าน',
  'auth.emailPriklad': 'you@example.com',
  'auth.prihlasitSe': 'เข้าสู่ระบบ',
  'auth.prihlasuji': 'กำลังเข้าสู่ระบบ…',
  'auth.zapomenuteHeslo': 'ลืมรหัสผ่าน?',
  'auth.presGoogle': 'เข้าสู่ระบบด้วย Google',
  'auth.spatneUdaje': 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
  'auth.uspech': 'เข้าสู่ระบบแล้ว',
  'auth.googleChyba': 'เข้าสู่ระบบด้วย Google ไม่สำเร็จ',
  'auth.obnoveniHesla': 'ตั้งรหัสผ่านใหม่',
  'auth.obnoveniOdeslano': 'ถ้าอีเมลนี้ลงทะเบียนไว้ คุณจะได้รับลิงก์สำหรับตั้งรหัสผ่านใหม่',
  'auth.zpetNaPrihlaseni': 'กลับไปหน้าเข้าสู่ระบบ',
  'auth.odeslatOdkaz': 'ส่งลิงก์',
  'auth.obnoveniChyba': 'ส่งอีเมลไม่สำเร็จ ลองอีกครั้ง',

  // druhý krok přihlášení
  'auth.jesteKod': 'อีกขั้นตอนเดียว: รหัสของคุณ',
  'auth.jesteKodPopis': 'เปิดแอปยืนยันตัวตนแล้วกรอกตัวเลขหกหลักที่แสดงสำหรับ Bloom',
  'auth.kod': 'รหัส',
  'auth.zalozniKodNapoveda': 'ไม่มีมือถืออยู่ใกล้ตัว? กรอกรหัสสำรองที่คุณเก็บไว้ตอนเปิดใช้งาน',
  'auth.potvrdit': 'ยืนยัน',
  'auth.overuji': 'กำลังตรวจสอบ…',
  'auth.kodNesedi': 'รหัสนี้ไม่ถูกต้อง',
  'auth.zalozniDochazeji': (p) => `คุณเหลือรหัสสำรองเพียง ${p.pocet} รหัส สร้างชุดใหม่ได้ในโปรไฟล์`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'วิธีติดตั้ง Bloom บนมือถือ',
  'auth.krokyAndroid': [
      'เปิดหน้านี้ใน Chrome',
      'แตะไอคอนสามจุด (⋮) มุมขวาบน',
      'เลือก «เพิ่มไปยังหน้าจอหลัก» หรือ «ติดตั้งแอป»',
      'ยืนยันการติดตั้ง',
    ],
  'auth.krokyIos': [
      'เปิดหน้านี้ใน Safari',
      'แตะไอคอนแชร์ (□↑) ที่แถบด้านล่าง',
      'เลื่อนลงแล้วเลือก «เพิ่มไปยังหน้าจอโฮม»',
      'ยืนยันด้วยการแตะ «เพิ่ม»',
    ],
  'auth.seznamChranene': [
      { silne: 'ไม่มีข้อมูลของสมาชิกที่เป็นสาธารณะ', text: 'โปรไฟล์ เรื่องราว ข้อเสนอ คำถาม รูปภาพ และอวาตาร์ จะแสดงเฉพาะกับผู้ที่เข้าสู่ระบบแล้ว สิ่งเหล่านี้ดาวน์โหลดหรือเก็บรวบรวมไม่ได้หากไม่มีบัญชี' },
      { silne: 'ไม่มีใครรู้รหัสผ่านของคุณ', text: '— เราก็ไม่รู้ ระบบเก็บเพียงลายนิ้วมือ bcrypt ซึ่งย้อนกลับไปเป็นรหัสผ่านเดิมไม่ได้' },
      { silne: 'ข้อความส่วนตัวและไฟล์แนบถูกเข้ารหัส', text: '(AES + ตรวจสอบความถูกต้อง) ตั้งแต่บนดิสก์ของเซิร์ฟเวอร์ ใครได้สำเนาสำรองหรือดิสก์ไปก็จะอ่านได้แค่ตัวอักษรที่ไม่มีความหมาย' },
      { silne: 'ข้อความลบตัวเอง', text: 'หลังจากช่วงเวลาหนึ่ง (ค่าเริ่มต้น 90 วัน) รวมถึงข้อความเสียงและรูปภาพ สิ่งที่ไม่อยู่ที่นี่ก็รั่วไหลไม่ได้' },
      { silne: 'ระยะการข้ามเพศของคุณเป็นเรื่องส่วนตัว', text: 'จนกว่าคุณจะเผยแพร่เอง ขั้นตอนที่คุณติ๊กไว้ในคู่มือ มีแต่คุณเท่านั้นที่เห็น' },
      { silne: 'อีเมลและเบอร์โทร', text: 'ไม่เคยถูกแสดงให้สมาชิกคนอื่นเห็น' },
      { silne: '', text: 'การเข้าสู่ระบบมีการป้องกันการเดารหัสผ่าน โดยจำกัดจำนวนครั้งที่ลองได้' },
      { silne: 'การเข้ารหัสข้อความแบบต้นทางถึงปลายทาง', text: 'เมื่อคุณเปิดใช้ ข้อความและไฟล์แนบจะถูกเข้ารหัสในเบราว์เซอร์ของคุณเอง และเซิร์ฟเวอร์ได้รับเพียงตัวอักษรที่อ่านไม่ออก กุญแจเปิดด้วยรหัสผ่านของคุณและไม่เคยออกจากอุปกรณ์ของคุณ เราจึงอ่านเนื้อหาไม่ได้เช่นกัน แม้ศาลจะสั่งก็ตาม ราคาที่ต้องจ่ายคือ ถ้าคุณลืมรหัสผ่าน คุณก็อ่านข้อความเก่าไม่ได้เหมือนกัน' },
      { silne: '', text: 'การเข้าสู่ระบบไม่ค้างอยู่ตลอด Bloom จะออกจากระบบให้เมื่อคุณปิดหน้าต่าง และหลังจากไม่มีการใช้งานสิบนาที' },
    ],
  'auth.seznamNeumime': [
      { silne: 'ข้อมูลกำกับ', text: '— ใครเขียนถึงใครและเมื่อไร — เซิร์ฟเวอร์ต้องรู้ ไม่อย่างนั้นก็ส่งข้อความไม่ได้ การเข้ารหัสต้นทางถึงปลายทางไม่ได้ซ่อนสิ่งนี้ Signal ก็เช่นกัน' },
      { silne: '', text: 'Bloom เป็นเว็บแอป จึงดาวน์โหลดโค้ดเข้ารหัสจากเซิร์ฟเวอร์ของเราทุกครั้งที่เปิด ใครยึดเซิร์ฟเวอร์ได้ในทางทฤษฎีก็อาจส่งโค้ดที่ถูกแก้ไขมาได้ สิ่งที่ป้องกันได้มีเพียงแอปที่เซ็นรับรองจากสโตร์ — นั่นคือเหตุผลที่ Signal มีแอป ส่วนเวอร์ชันเว็บไม่มี' },
      { silne: 'โปรไฟล์', text: '— ชื่อเล่น คำอธิบาย อวาตาร์ — เข้ารหัสไม่ได้ เพราะเซิร์ฟเวอร์ต้องแสดงให้คนอื่นเห็น' },
      { silne: '', text: 'ข้อความจากก่อนเปิดการเข้ารหัสจะถูกเข้ารหัสแค่บนดิสก์ของเซิร์ฟเวอร์ ไม่ใช่แบบต้นทางถึงปลายทาง' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom ทำงานเหมือนแอป แม้ตอนออฟไลน์ ข้อมูลของคุณอัปเดตเสมอ',
  'auth.zabezpeceniTitulek': 'Bloom ปลอดภัยอย่างไร',
  'auth.zabezpeceniUvod': 'Bloom เป็นพื้นที่สำหรับชุมชนคนข้ามเพศ เรื่องละเอียดอ่อนจึงมาเจอกันที่นี่ ด้านล่างคือสิ่งที่ '
      + 'เราทำเพื่อปกป้องมัน — และสิ่งที่เราทำไม่ได้ — โดยไม่ตกแต่งให้ดูดี',
  'auth.coJeChranene': 'สิ่งที่ได้รับการปกป้อง',
  'auth.coNeumime': 'สิ่งที่ Bloom ทำไม่ได้ — และควรพูดตรง ๆ',
  'auth.zabezpeceniZaver': 'ถ้าคุณมีคำถามเรื่องความเป็นส่วนตัว หรือพบช่องโหว่ ใช้ปุ่ม «แจ้งปัญหา» ด้านล่าง เราถือเรื่องนี้เป็นเรื่องจริงจัง',
  'auth.mvp': 'Bloom อยู่ในเวอร์ชันแรก และเราพัฒนามันไปพร้อมกับชุมชน '
      + 'ถ้าคุณเจอข้อผิดพลาดหรือมีไอเดีย เรายินดีที่จะได้รู้',
  'auth.nahlasitProblem': 'แจ้งปัญหา',
  'auth.clenu': () => 'สมาชิก',
  'auth.prispevku': () => 'โพสต์',
  'auth.odborniku': () => 'ผู้เชี่ยวชาญ',
  'auth.nabidek': () => 'ข้อเสนอ',

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'ชื่อเล่น (ไม่ซ้ำใคร)',
  'reg.prezdivkaPriklad': 'อย่างน้อย 3 ตัวอักษร',
  'reg.telefon': 'โทรศัพท์',
  'reg.volitelne': '(ไม่บังคับ)',
  'reg.heslo': 'รหัสผ่าน',
  'reg.hesloZnovu': 'กรอกรหัสผ่านอีกครั้ง',
  'reg.zajmeno': 'คำสรรพนาม',
  'reg.oMne': 'เกี่ยวกับฉัน',
  'reg.oMnePriklad': 'สองสามคำเกี่ยวกับคุณ…',
  'reg.registrovat': 'สร้างบัญชี',
  'reg.registruji': 'กำลังสร้างบัญชี…',
  'reg.presGoogle': 'สมัครด้วย Google',
  'reg.avatar': 'อวาตาร์',
  'reg.neboFoto': 'หรืออัปโหลดรูปของคุณเอง',
  'reg.nahratFoto': 'อัปโหลดรูป',
  'reg.vlastni': 'รูปของฉัน',
  'reg.zeme': 'ประเทศ',
  'reg.kraj': 'ภูมิภาค',
  'reg.nechciUvadet': 'ขอไม่ระบุ',
  'reg.cesko': 'เช็กเกีย',
  'reg.svet': 'ส่วนอื่นของโลก',

  // skupiny avatarů
  'reg.avatarFem': 'ผู้หญิง',
  'reg.avatarMask': 'ผู้ชาย',
  'reg.avatarNeutr': 'เป็นกลาง',
  'reg.avatarZvirata': 'สัตว์',

  // komunitní heslo
  'reg.komunitniHeslo': 'รหัสผ่านของชุมชน',
  'reg.komunitniHesloPriklad': 'กรอกรหัสผ่านของชุมชน…',
  'reg.komunitniHesloPopis': 'Bloom เป็นพื้นที่ส่วนตัวของชุมชนคนข้ามเพศ คนในชุมชนสามารถให้รหัสผ่านกับคุณได้',
  'reg.napisAdminovi': 'ถ้าคุณไม่รู้จักใคร เขียนถึงผู้ดูแลได้ที่',
  'reg.nevimHeslo': 'ฉันไม่รู้รหัสผ่านของชุมชน',
  'reg.jakZiskat': 'รหัสผ่านของชุมชนปกป้องพื้นที่ส่วนตัวนี้ วิธีขอรหัส:',
  'reg.krok1': '1. เขียนอีเมลไปที่',
  'reg.krok2': '2. แนะนำตัวสั้น ๆ และบอกว่าคุณรู้จัก Bloom จากไหน',
  'reg.krok3': '3. ผู้ดูแลจะตอบกลับโดยเร็วที่สุด',

  // kontrola hesla
  'reg.hesloKratke': 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร',
  'reg.hesloMale': 'รหัสผ่านต้องมีตัวพิมพ์เล็ก',
  'reg.hesloVelke': 'รหัสผ่านต้องมีตัวพิมพ์ใหญ่',
  'reg.hesloCislo': 'รหัสผ่านต้องมีตัวเลข',
  'reg.hesloZnak': 'รหัสผ่านต้องมีอักขระพิเศษ (!@#$%…)',
  'reg.pozadavek8': 'อย่างน้อย 8 ตัวอักษร',
  'reg.pozadavekVelke': 'ตัวพิมพ์ใหญ่',
  'reg.pozadavekCislo': 'ตัวเลข',
  'reg.pozadavekZnak': 'อักขระพิเศษ (!@#$%)',
  'reg.hesloNesouhlasi': 'รหัสผ่านไม่ตรงกัน',
  'reg.prezdivkaKratka': 'ชื่อเล่นต้องมีอย่างน้อย 3 ตัวอักษร',
  'reg.hesloPovinne': 'ต้องกรอกรหัสผ่านของชุมชน',
  'reg.hotovo': 'สร้างบัญชีแล้ว ตรวจอีเมลเพื่อยืนยัน',
  'reg.fotoVelka': 'รูปใหญ่เกินไป (สูงสุด 2 MB)',
  'reg.chyba': 'สร้างบัญชีไม่สำเร็จ',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'ที่นี่ไม่มีใครต้องสมบูรณ์แบบ Bloom คือพื้นที่ที่ทุกคนเป็นตัวเองได้ — '
      + 'ที่คุณแบ่งปันประสบการณ์ ถามคำถาม และช่วยคนอื่นได้ โดยไม่ถูกตัดสินและไม่มีอคติ',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · แปลจากภาษาเช็ก',
  'domu.vitej': 'สวัสดี',
  'domu.vCislech': 'Bloom เป็นตัวเลข',
  'domu.noveVKomunite': 'มาที่นี่ครั้งแรก?',
  'domu.noveVKomunitePopis1': 'คุณไม่ต้องเปิดเผยตัว ไม่ต้องมีรูป ไม่ต้องเปิดเผยตัวตนกับใคร',
  'domu.noveVKomunitePopis2': 'Bloom คือพื้นที่ที่คุณเริ่มได้ในจังหวะของตัวเอง',
  'domu.rozcestnik1': 'ฉันมาที่นี่ครั้งแรก',
  'domu.rozcestnik2': 'ฉันไม่รู้จะเริ่มตรงไหน',
  'domu.rozcestnik3': 'ฉันอยากไม่เปิดเผยตัว',
  'domu.rozcestnik4': 'ฉันกำลังหาผู้เชี่ยวชาญ',
  'domu.rozcestnik5': 'ฉันแค่อยากอ่านประสบการณ์ของคนอื่น',
  'domu.otazky': 'มีคำถามหรืออยากรู้มากกว่านี้? เขียนถึงเราได้ที่',
  'domu.doporucujeme': 'แนะนำ',
  'domu.odbornici': 'ผู้เชี่ยวชาญ',
  'domu.noviClenove': 'คนใหม่ในชุมชน',
  'domu.zadniNovi': 'ยังไม่มีใครใหม่',
  'domu.nejnovejsiOtazky': 'คำถามล่าสุด',
  'domu.zadneOtazky': 'ยังไม่มีคำถาม',
  'domu.nejlepeHodnoceni': 'ผู้เชี่ยวชาญที่ได้คะแนนสูงสุด',
  'domu.zadniHodnoceni': 'ยังไม่มีการให้คะแนน',
  'domu.zadneAktuality': 'ยังไม่มีข่าว',

  // dlaždice sekcí
  'domu.dlazdice.support': 'เสนอสิ่งที่คุณทำได้ และรับความช่วยเหลือจากคนอื่น',
  'domu.dlazdice.specialists': 'หาผู้เชี่ยวชาญที่ผ่านการตรวจสอบ ตั้งแต่จิตวิทยาจนถึงศัลยกรรมตกแต่ง',
  'domu.dlazdice.legal': 'ความช่วยเหลือทางกฎหมาย บทความ และคำตอบสำหรับคำถามของคุณ',
  'domu.dlazdice.nearby': 'บริการและผู้เชี่ยวชาญใกล้คุณ',

  // počty
  'domu.pocetClenu': () => 'คนในชุมชน',
  'domu.pocetZkusenosti': () => 'ประสบการณ์ที่แบ่งปัน',
  'domu.pocetOdborniku': () => 'ผู้เชี่ยวชาญที่ตรวจสอบแล้ว',
  'domu.pocetNabidek': () => 'ข้อเสนอช่วยเหลือ',

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'หน้าแรก',
  'nav.news': 'ข่าวสาร',
  'nav.stories': 'ประสบการณ์ของชุมชน',
  'nav.mapaSveta': 'แผนที่โลก',
  'nav.support': 'ช่วยเหลือกัน',
  'nav.specialists': 'ผู้เชี่ยวชาญที่เป็นมิตรกับคนข้ามเพศ',
  'nav.legal': 'ความช่วยเหลือทางกฎหมาย',
  'nav.pageants': 'การประกวด',
  'nav.nearby': 'ใกล้ฉัน',
  'nav.hledat': 'ค้นหาใน Bloom',
  'nav.hledatPlaceholder': 'ค้นหาคน ผู้เชี่ยวชาญ บทความ…',
  'nav.zpravy': 'ข้อความ',
  'nav.profil': 'โปรไฟล์ของฉัน',
  'nav.mojeCesta': 'เส้นทางของฉัน',
  'nav.administrace': 'ผู้ดูแลระบบ',
  'nav.odhlasit': 'ออกจากระบบ',
  'nav.vsechnyVysledky': (p) => `ดูผลลัพธ์ทั้งหมดสำหรับ «${p.dotaz}»`,
  'nav.overEmail': 'ยืนยันอีเมลของคุณ',
  'nav.menu': 'เมนู',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Bloom ทั่วโลก',
  'svet.podtitulek': 'เลือกประเทศแล้วดูว่าชุมชนรวบรวมอะไรไว้ที่นั่น',
  'svet.hledatZemi': 'ค้นหาประเทศ…',
  'svet.vsechnyZeme': 'ทุกประเทศ',
  'svet.jenSObsahem': 'เฉพาะประเทศที่มีเนื้อหา',
  'svet.nicNenalezeno': 'ไม่มีประเทศที่ตรงกัน',
  'svet.zaznamu': (p) => `${p.pocet} รายการ`,
  'svet.prazdnaZeme': 'ยังไม่มีอะไร',
  'svet.kontinent': 'ทวีป',
  'svet.celySvet': 'ทั้งโลก',
  'svet.vse': 'ทั้งหมด',
  'svet.zacniDomovem': 'เริ่มจากเลือกประเทศที่คุณอยู่ เลือกจากรายการใต้แผนที่ก็ได้',
  'svet.zkoumej': 'เลือกประเทศแล้วดูว่า Bloom มีอะไรที่นั่น คุณดูที่ไหนก็ได้ — '
      + 'ไม่ได้เปลี่ยนประเทศของคุณ',
  'svet.domov': 'บ้าน',
  'svet.zrusitDomov': 'เอาประเทศที่อยู่ออก',
  'svet.nastavitDomov': 'ตั้งเป็นประเทศของฉัน',
  'svet.zeSveta': 'จากทั่วโลก',
  'svet.coSeChysta': 'กำลังจะมาถึง',
  'svet.souteze': 'การประกวดที่เปิดรับสมัคร',
  'svet.noveOrganizace': 'องค์กรใหม่',
  'svet.kdeJizNeco': 'ที่ที่ Bloom มีอะไรแล้ว',
  'svet.hledatZemiPopisek': 'ค้นหาประเทศ',
  'svet.nicNeodpovida': 'ไม่มีอะไรตรงกัน ลองค้นแบบอื่น',
  'svet.napovedaKMape': 'ลากแผนที่เพื่อเลื่อน และซูมด้วยล้อเมาส์หรือปุ่ม คุณไม่จำเป็น '
      + 'ต้องใช้มัน — ช่องค้นหาและรายชื่อประเทศทั้งหมดอยู่ด้านล่าง',
  'svet.tvujBloom': (p) => `Bloom ของคุณใน ${p.zeme}`,
  'svet.tvojeDomovska': 'ประเทศที่คุณอยู่',
  'svet.zemi': (p) => `${p.pocet} ประเทศ`,
  'svet.chyba': 'โหลดรายชื่อประเทศไม่สำเร็จ ลองโหลดหน้านี้ใหม่',
  'svet.pocet.specialists': (p) => `ผู้เชี่ยวชาญ ${p.pocet} คน`,
  'svet.pocet.organizations': (p) => `องค์กร ${p.pocet} แห่ง`,
  'svet.pocet.events': (p) => `กิจกรรม ${p.pocet} รายการ`,
  'svet.pocet.pageants': (p) => `การประกวด ${p.pocet} รายการ`,
  'svet.pocet.resources': (p) => `แหล่งข้อมูล ${p.pocet} รายการ`,

  // světadíly
  'kontinent.europe': 'ยุโรป',
  'kontinent.asia': 'เอเชีย',
  'kontinent.africa': 'แอฟริกา',
  'kontinent.north_america': 'อเมริกาเหนือ',
  'kontinent.south_america': 'อเมริกาใต้',
  'kontinent.oceania': 'โอเชียเนีย',
  'kontinent.antarctica': 'แอนตาร์กติกา',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'การประกวดของคนข้ามเพศจากทั่วโลก รายการที่ยังสมัครได้อยู่ด้านบน',
  'souteze.hledat': 'ค้นหาการประกวด…',
  'souteze.zadne': 'เรายังไม่มีการประกวดใด ๆ คุณรู้จักที่ไหนไหม? ส่งข้อเสนอแนะมาได้',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `เปิด: ${p.zeme}`,
  'nahled.zavrit': 'ปิดตัวอย่าง',
  'nahled.jenInformace': 'ตอนนี้เรามีเพียงข้อมูลเกี่ยวกับประเทศนี้',
  'nahled.zatimNic': 'ที่นี่เรายังไม่มีผู้ติดต่อ องค์กร หรือกิจกรรม คุณรู้จักอะไรไหม? ส่งข้อเสนอแนะมาได้',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom ใน ${p.zeme}`,
  'zeme.podtitulek': (p) => `สิ่งที่ชุมชนรวบรวมไว้ใน ${p.zeme}`,
  'zeme.prazdna': 'Bloom เพิ่งเริ่มต้นที่นี่ คุณอาจเป็นคนแรกที่เพิ่มอะไรสักอย่าง',
  'zeme.mapaSveta': 'แผนที่โลก',
  'zeme.navrhnout': 'เสนอรายการ',
  'zeme.domovska': 'ประเทศที่คุณอยู่',
  'zeme.nastavitDomovskou': 'ตั้งเป็นประเทศของฉัน',
  'zeme.kdeToJe': 'หาได้ที่ไหน',
  'zeme.coTuBude': 'คุณจะเจออะไรที่นี่',
  'zeme.zatimPrazdne': 'ตอนนี้ยังว่าง',
  'zeme.pripravujeme': 'กำลังเตรียม',
  'zeme.zobrazitVse': (p) => `ดูทั้งหมด (${p.pocet})`,
  'zeme.rosteTitulek': 'Bloom เพิ่งเริ่มเติบโตที่นี่',
  'zeme.rostePopis': 'ที่นี่เรายังไม่มีอะไร คุณรู้จักองค์กร กิจกรรม หรือผู้ติดต่อที่เป็นประโยชน์ไหม? '
      + 'ส่งข้อเสนอแนะมาได้ — จะผ่านการตรวจสอบแล้วจึงปรากฏที่นี่',
  'zeme.jinouZemi': 'ดูประเทศอื่น',
  'zeme.bezKontaktu': 'ที่นี่เรายังไม่มีผู้ติดต่อหรือองค์กร',
  'zeme.bezKontaktuPopis': 'คุณรู้จักใครหรืออะไรที่เป็นประโยชน์ที่นี่ไหม? ส่งข้อเสนอแนะมาได้ — '
      + 'จะผ่านการตรวจสอบแล้วจึงปรากฏที่นี่',
  'zeme.neznama': 'เราไม่รู้จักประเทศนี้',
  'zeme.chyba': 'โหลดข้อมูลประเทศไม่สำเร็จ',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'คลินิกและโรงพยาบาล',
  'sekce.specialists.popis': 'แพทย์ คลินิก และผู้เชี่ยวชาญอื่น ๆ ที่ชุมชนมีประสบการณ์ด้วย',
  'sekce.organizations': 'องค์กร',
  'sekce.organizations.popis': 'สมาคม องค์กรไม่แสวงหากำไร และกลุ่มสนับสนุน',
  'sekce.events': 'กิจกรรม',
  'sekce.events.popis': 'การพบปะ ไพรด์ เวิร์กช็อป และการประชุม',
  'sekce.pageants': 'การประกวด',
  'sekce.pageants.popis': 'การประกวดของคนข้ามเพศและกำหนดการ',
  'sekce.resources': 'แหล่งข้อมูล',
  'sekce.resources.popis': 'ข้อมูลที่ใช้ได้จริงเกี่ยวกับประเทศนี้',
  'sekce.community': 'ชุมชน',
  'sekce.community.popis': 'ผู้คนและกลุ่มในประเทศนี้',
  'sekce.legal': 'ความช่วยเหลือทางกฎหมาย',
  'sekce.legal.popis': 'ข้อมูลและการสนับสนุนสำหรับชุมชนคนข้ามเพศ',
  'sekce.support': 'ช่วยเหลือกัน',
  'sekce.support.popis': 'เสนอสิ่งที่คุณทำได้ และรับความช่วยเหลือจากคนอื่นในชุมชน',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'ค้นหาในประเทศนี้…',
  'vypis.vsechnyKategorie': 'ทุกหมวดหมู่',
  'vypis.kategorie': 'หมวดหมู่',
  'vypis.celaZeme': 'ทั้งประเทศ',
  'vypis.navrhnout': 'เสนอ',
  'vypis.nicNeodpovida': 'ไม่มีอะไรตรงกัน ลองค้นแบบอื่นหรือเอาตัวกรองออก',
  'vypis.zadneZaznamy': (p) => `ใน ${p.zeme} เรายังไม่มีรายการ`,
  'vypis.zaznamu': (p) => `${p.pocet} รายการ`,
  'vypis.predchozi': 'ก่อนหน้า',
  'vypis.dalsi': 'ถัดไป',
  'vypis.chyba': 'โหลดรายการไม่สำเร็จ',
  'vypis.neznamyDruh': 'เราไม่รู้จักรายการประเภทนี้',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `กลับไป: ${p.zeme}`,
  'detail.kontakty': 'ติดต่อและลิงก์',
  'detail.podrobnosti': 'รายละเอียด',
  'detail.zacatek': 'เริ่ม',
  'detail.termin': 'วันที่',
  'detail.uzaverka': 'ปิดรับสมัคร',
  'detail.prihlaska': 'สมัคร',
  'detail.strankaAkce': 'หน้ากิจกรรม',
  'detail.web': 'เว็บไซต์',
  'detail.konec': 'สิ้นสุด',
  'detail.stavRocniku': 'สถานะของปีนี้',
  'detail.oblasti': 'ด้านที่ทำงาน',
  'detail.coNabizi': 'สิ่งที่เสนอ',
  'detail.kategorie': 'หมวดหมู่',
  'detail.jazyky': 'ภาษา',
  'detail.vitezove': 'ผู้ชนะครั้งก่อน',
  'detail.kdoSeMuze': 'ใครสมัครได้',
  'detail.poradatel': 'ผู้จัด',
  'detail.poplatek': 'ค่าธรรมเนียม',
  'detail.tema': 'หัวข้อ',
  'detail.forma.offline': 'พบกันจริง',
  'detail.forma.online': 'ออนไลน์',
  'detail.forma.hybrid': 'พบกันจริงและออนไลน์',
  'detail.rozsah.local': 'ระดับท้องถิ่น',
  'detail.rozsah.national': 'ระดับประเทศ',
  'detail.rozsah.international': 'ระดับนานาชาติ',
  'detail.rocnik.upcoming': 'กำลังจะมาถึง',
  'detail.rocnik.registration_open': 'เปิดรับสมัคร',
  'detail.rocnik.registration_closed': 'ปิดรับสมัครแล้ว',
  'detail.rocnik.completed': 'จบไปแล้ว',
  'detail.zdroj': (p) => `แหล่งที่มา: ${p.zdroj}`,
  'detail.upraveno': (p) => `แก้ไขล่าสุด: ${p.datum}`,
  'detail.overeno': 'ตรวจสอบแล้วว่าตรงกับความจริง นี่ไม่ใช่คำแนะนำจาก Bloom',
  'detail.neovereno': 'รายการนี้ยังไม่ได้ตรวจสอบ ข้อมูลอาจเปลี่ยนไปแล้ว — โปรดตรวจกับแหล่งที่มา',
  'detail.nenalezen': 'เราไม่รู้จักรายการนี้ อาจถูกลบไปแล้วหรือยังรอตรวจสอบอยู่',
  'detail.chyba': 'โหลดรายการนี้ไม่สำเร็จ',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'ที่นี่ใช้กฎอะไร',
  'profil.name_change': 'การเปลี่ยนชื่อ',
  'profil.gender_marker': 'การเปลี่ยนคำนำหน้า/เพศในเอกสาร',
  'profil.surgery_required': 'ต้องผ่าตัดหรือไม่',
  'profil.healthcare': 'การเข้าถึงบริการสุขภาพ',
  'profil.legal_protection': 'การคุ้มครองจากการเลือกปฏิบัติ',
  'profil.safety': 'ความปลอดภัย',
  'profil.stav.yes': 'ใช่',
  'profil.stav.limited': 'บางส่วน',
  'profil.stav.no': 'ไม่',
  'profil.stav.unknown': 'ไม่มีข้อมูล',
  'profil.zdroj': 'แหล่งที่มา',
  'profil.zdrojZRoku': (p) => `แหล่งที่มาจากปี ${p.rok}`,
  'profil.overeno': (p) => `ตรวจสอบเมื่อ ${p.datum}`,
  'profil.zmena': 'การเปลี่ยนแปลงล่าสุด',
  'profil.odKdy': (p) => `มีผลตั้งแต่ ${p.datum}`,
  'profil.doklady': 'แหล่งที่มา',
  'profil.zakon': 'กฎหมายหรือคำพิพากษา',
  'profil.upozorneni': 'นี่ไม่ใช่คำปรึกษาทางกฎหมาย กฎหมายเปลี่ยนได้และหลายอย่างขึ้นกับ '
      + 'สถานการณ์เฉพาะของคุณ — โปรดตรวจกับแหล่งที่มาหรือกับองค์กรใน '
      + 'ประเทศนั้นก่อนตัดสินใจ',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `เสนอ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'ข้อเสนอของคุณจะผ่านการตรวจสอบก่อนปรากฏใน Bloom กรอกเท่าที่ '
      + 'คุณรู้ — ที่เหลือเราจะเติมให้',
  'navrh.jednotne.organizations': 'องค์กร',
  'navrh.jednotne.events': 'กิจกรรม',
  'navrh.jednotne.pageants': 'การประกวด',
  'navrh.jednotne.resources': 'แหล่งข้อมูล',
  'navrh.popis.organizations': 'สมาคม องค์กรไม่แสวงหากำไร หรือกลุ่มสนับสนุน',
  'navrh.popis.events': 'การพบปะ ไพรด์ เวิร์กช็อป การประชุม',
  'navrh.popis.pageants': 'การประกวดของคนข้ามเพศ – วันที่ การสมัคร ผู้จัด',
  'navrh.popis.resources': 'ข้อมูลที่ใช้ได้จริง – สุขภาพ กฎหมาย เอกสาร ผู้ติดต่อ',
  'navrh.nazev': 'ชื่อ',
  'navrh.popisPole': 'คำอธิบาย',
  'navrh.zeme': 'ประเทศ',
  'navrh.mesto': 'เมือง',
  'navrh.adresa': 'ที่อยู่',
  'navrh.web': 'เว็บไซต์',
  'navrh.email': 'อีเมล',
  'navrh.telefon': 'โทรศัพท์',
  'navrh.odkudVis': 'คุณรู้จากไหน',
  'navrh.odkudVisPriklad': 'เช่น จากเว็บไซต์ของเขา ฉันเคยไปที่นั่น…',
  'navrh.vyberte': '— เลือก —',
  'navrh.forma': 'รูปแบบ',
  'navrh.rozsah': 'ขอบเขต',
  'navrh.platiPro': 'ใช้กับ',
  'navrh.platnost.global': 'ทั้งโลก',
  'navrh.platnost.country': 'ประเทศหนึ่ง',
  'navrh.platnost.region': 'ภูมิภาคหนึ่ง',
  'navrh.platnost.city': 'เมืองหนึ่ง',
  'navrh.odkazAkce': 'ลิงก์กิจกรรม',
  'navrh.odkazPrihlaska': 'ลิงก์สมัคร',
  'navrh.odkazy': 'ลิงก์',
  'navrh.text': 'ข้อความ',
  'navrh.odeslat': 'ส่งข้อเสนอ',
  'navrh.odesilam': 'กำลังส่ง…',
  'navrh.chyba': 'ส่งข้อเสนอไม่สำเร็จ',
  'navrh.dikyTitulek': 'ขอบคุณ เราได้รับแล้ว',
  'navrh.dikyPopis': 'เราได้รับข้อเสนอของคุณแล้ว จะมีคนตรวจดูแล้วจึงปรากฏ '
      + 'ใน Bloom ไม่มีอะไรถูกเผยแพร่โดยอัตโนมัติ',
  'navrh.zavrit': 'ปิด',
  'navrh.seznamNapoveda': 'คั่นรายการด้วยเครื่องหมายจุลภาค',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `${p.druh}นี้เป็นของคุณหรือเปล่า?`,
  'prevzeti.popis': 'คุณรับดูแลโปรไฟล์นี้และคอยอัปเดตข้อมูลได้ '
      + 'คำขอจะผ่านการตรวจสอบก่อน',
  'prevzeti.tlacitko': 'รับดูแลโปรไฟล์นี้',
  'prevzeti.spravujes': 'คุณดูแลโปรไฟล์นี้ แก้ข้อมูลได้ทุกเมื่อ — การเปลี่ยนแปลงมีผลทันที',
  'prevzeti.upravit': 'แก้ไขข้อมูล',
  'prevzeti.spravujeSama': (p) => `โปรไฟล์นี้ดูแลโดย${p.druh}เอง`,
  'prevzeti.ceka': 'เราได้รับคำขอของคุณแล้วและกำลังพิจารณา',
  'prevzeti.formulacTitulek': (p) => `รับดูแลโปรไฟล์ — ${p.nazev}`,
  'prevzeti.formulacPopis': 'ก่อนส่งมอบโปรไฟล์ เราต้องรู้ว่าคุณเป็นส่วนหนึ่งขององค์กรนี้จริง ๆ '
      + 'คำขอจะผ่านการตรวจสอบ ตอนนี้ยังไม่มีอะไรเปลี่ยน',
  'prevzeti.role': 'บทบาทของคุณที่นั่นคืออะไร?',
  'prevzeti.rolePriklad': 'เช่น ผู้ประสานงาน ประธานสมาคม',
  'prevzeti.doklad': 'เราตรวจสอบได้อย่างไร?',
  'prevzeti.dokladPriklad': 'เช่น ชื่อฉันอยู่ในหน้าติดต่อขององค์กร หรือเขียนมาจากอีเมลทางการ',
  'prevzeti.dokladNapoveda': 'ลิงก์ไปยังหน้าที่มีชื่อคุณก็พอ หรือใช้อีเมลทางการ '
      + 'ขององค์กรเขียนมา',
  'prevzeti.kontakt': 'การติดต่อของคุณ',
  'prevzeti.kontaktPriklad': 'อีเมลหรือโทรศัพท์',
  'prevzeti.dalsi': 'อย่างอื่นอีก',
  'prevzeti.nepovinne': '(ไม่บังคับ)',
  'prevzeti.odeslat': 'ส่งคำขอ',
  'prevzeti.odesilam': 'กำลังส่ง…',
  'prevzeti.vyplnObe': 'บอกเราว่าบทบาทของคุณคืออะไรและตรวจสอบได้อย่างไร',
  'prevzeti.prijato': 'ขอบคุณ เราได้รับคำขอของคุณและจะตอบกลับ',
  'prevzeti.chyba': 'ส่งคำขอไม่สำเร็จ',
  'prevzeti.upravaTitulek': (p) => `แก้ไขโปรไฟล์ — ${p.nazev}`,
  'prevzeti.upravaPopis': 'ชื่อและสถานที่ไม่อยู่ที่นี่โดยตั้งใจ เพราะรายการถูกค้นหาและ '
      + 'จัดเรียงตามสิ่งเหล่านั้น ถ้ามันเปลี่ยนไป เขียนมาบอกเราแล้วเราจะอัปเดตให้',
  'prevzeti.popisPole': 'คำอธิบาย',
  'prevzeti.email': 'อีเมล',
  'prevzeti.telefon': 'โทรศัพท์',
  'prevzeti.web': 'เว็บไซต์',
  'prevzeti.ulozeno': 'บันทึกแล้ว',
  'prevzeti.ukladam': 'กำลังบันทึก…',
  'prevzeti.chybaUlozeni': 'บันทึกไม่สำเร็จ',
  'prevzeti.druh.organizations': 'องค์กร',
  'prevzeti.druh.events': 'กิจกรรม',
  'prevzeti.druh.pageants': 'การประกวด',

  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'แก้ไขข้อมูลและการตั้งค่าของคุณ',
  'profil.overeny': 'ยืนยันแล้ว',
  'profil.neovereny': 'ยังไม่ยืนยัน',
  'profil.overteEmail': 'โปรดยืนยันอีเมลของคุณ บัญชีที่ยังไม่ยืนยันมีสิทธิ์จำกัด',
  'profil.emailOdeslan': 'ส่งอีเมลยืนยันแล้ว',
  'profil.emailChyba': 'ส่งอีเมลไม่สำเร็จ',
  'profil.odeslano': 'ส่งแล้ว',
  'profil.overeniOdbornika': 'การยืนยันเป็นผู้เชี่ยวชาญหรือนักกฎหมาย',
  'profil.pracujeteVOboru': 'คุณทำงานในสาขานี้ใช่ไหม? รับตราสัญลักษณ์ยืนยัน',
  'profil.zadostOdeslana': 'ส่งคำขอแล้ว',
  'profil.pozadatOOvereni': 'ขอการยืนยัน',
  'profil.zadostTitulek': 'ขอการยืนยันเป็นผู้เชี่ยวชาญหรือนักกฎหมาย',
  'profil.zadostPopis': 'กรอกข้อมูลคำขอของคุณ ทีมดูแลจะพิจารณา',
  'profil.pozadovanaRole': 'บทบาทที่ขอ',
  'profil.roleOdbornik': 'ผู้เชี่ยวชาญ',
  'profil.rolePravnik': 'นักกฎหมาย',
  'profil.specializace': 'ความเชี่ยวชาญ',
  'profil.odkazNaProfil': 'ลิงก์ไปโปรไฟล์วิชาชีพ',
  'profil.zpravaProAdmina': 'ข้อความสั้น ๆ ถึงผู้ดูแล',
  'profil.odesilam': 'กำลังส่ง…',
  'profil.odeslatZadost': 'ส่งคำขอยืนยัน',
  'profil.vyplnteSpecializaci': 'กรอกความเชี่ยวชาญของคุณ',
  'profil.zadostUspech': 'ส่งคำขอยืนยันของคุณแล้ว',
  'profil.zadostChyba': 'ส่งคำขอไม่สำเร็จ',

  // bezpečnost
  'bezp.titulek': 'ความปลอดภัย',
  'bezp.sifrovaniZapnuto': (p) => `การเข้ารหัสข้อความเปิดอยู่${p.odemceno ? ' และปลดล็อกแล้ว' : ' (ล็อกอยู่ในแท็บนี้)'}`,
  'bezp.sifrovaniVypnuto': 'คุณยังไม่ได้เปิดการเข้ารหัสข้อความ',
  'bezp.sifrovaniKde': 'เปิดและปลดล็อกได้ที่หน้าข้อความ',
  'bezp.sifrovaniKdeVypnute': 'เปิดได้ที่หน้าข้อความ ในบทสนทนาใดก็ได้',
  'bezp.zmenaHesla': 'เปลี่ยนรหัสผ่าน',
  'bezp.zmenaHeslaSifrovani': 'คุณเปิดการเข้ารหัสอยู่ การเปลี่ยนรหัสผ่านจึงห่อกุญแจข้อความของคุณใหม่ด้วย '
      + 'จึงต้องใช้รหัสผ่านปัจจุบัน — ถ้าไม่มี ก็เปิดกุญแจไม่ได้และคุณจะเสียข้อความไป',
  'bezp.stavajiciHeslo': 'รหัสผ่านปัจจุบัน',
  'bezp.noveHeslo': 'รหัสผ่านใหม่',
  'bezp.noveHesloZnovu': 'กรอกรหัสผ่านใหม่อีกครั้ง',
  'bezp.pozadavky': 'อย่างน้อย 8 ตัวอักษร มีตัวพิมพ์ใหญ่และเล็ก ตัวเลข และอักขระพิเศษ',
  'bezp.zmenitHeslo': 'เปลี่ยนรหัสผ่าน',
  'bezp.menim': 'กำลังเปลี่ยน…',
  'bezp.hesloNeshoda': 'รหัสผ่านใหม่ไม่ตรงกัน',
  'bezp.vyplnObe': 'กรอกรหัสผ่านทั้งสองช่อง',
  'bezp.stareNesedi': 'รหัสผ่านปัจจุบันไม่ถูกต้อง — กุญแจข้อความของคุณจะหายไป เราจึงไม่เปลี่ยนอะไรเลย',
  'bezp.zmenenoSKlicem': 'เปลี่ยนรหัสผ่านแล้ว กุญแจข้อความของคุณถูกห่อใหม่ ข้อความเก่าจึงยังอ่านได้',
  'bezp.zmeneno': 'เปลี่ยนรหัสผ่านแล้ว',
  'bezp.zmenaChyba': 'เปลี่ยนรหัสผ่านไม่สำเร็จ',
  'bezp.nepamatujes': 'จำรหัสผ่านของกุญแจไม่ได้?',
  'bezp.zahoditPopis': 'คุณทิ้งกุญแจแล้วเริ่มใหม่ได้ ข้อความที่เข้ารหัสไว้จนถึงตอนนี้จะหายไปตลอดกาล — '
      + 'ไม่มีใครอ่านได้ เราก็ไม่ได้ และนั่นแหละคือเหตุผลที่มันปลอดภัย',
  'bezp.zahodit': 'ทิ้งกุญแจแล้วเริ่มใหม่',
  'bezp.zahoditPotvrzeni': 'จะทิ้งกุญแจจริง ๆ ใช่ไหม?\n\nข้อความทั้งหมดที่เข้ารหัสไว้จนถึงตอนนี้จะหายไปตลอดกาล — '
      + 'ไม่มีใครอ่านได้ เราก็ไม่ได้ ทำแบบนี้ก็ต่อเมื่อคุณจำรหัสผ่าน '
      + 'ที่ใช้ตอนเปิดการเข้ารหัสไม่ได้แล้ว',
  'bezp.klicSmazan': 'ลบกุญแจแล้ว โปรดโหลดหน้านี้ใหม่',
  'bezp.nepovedlo': 'ไม่สำเร็จ',
  'bezp.prohlizecNeumi': 'เบราว์เซอร์นี้ไม่รองรับการเข้ารหัสที่ Bloom ใช้',

  'profil.mujProfil': 'โปรไฟล์ของฉัน',
  'profil.specializacePriklad': 'เช่น จิตวิทยา เพศศาสตร์ กฎหมาย…',
  'profil.zpravaPriklad': 'เช่น ลิงก์ไปยังใบอนุญาตวิชาชีพหรือเว็บไซต์คลินิกของคุณ…',
  'profil.overeniUvod': 'อยากเป็นผู้เชี่ยวชาญหรือนักกฎหมายที่ผ่านการยืนยันบน Bloom ไหม? ส่งคำขอยืนยันมาได้ '
      + 'โปรไฟล์ของคุณต้องตรงกับอาชีพจริงของคุณ',

  'profil.oborPriklad': 'เช่น ศัลยกรรมตกแต่ง กฎหมายครอบครัว…',
  'profil.nepovinnyText': 'หมายเหตุเพิ่มเติม ไม่บังคับ…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'การเข้าสู่ระบบสองขั้นตอน',
  'dvf.zapnuto': (p) => `เปิดอยู่ คุณเหลือรหัสสำรอง ${p.pocet} รหัส`,
  'dvf.vypnuto': 'นอกจากรหัสผ่าน คุณยังกรอกรหัสหกหลักจากแอปในมือถือด้วย',
  'dvf.chraniA': 'มันปกป้อง',
  'dvf.chraniPrihlaseni': 'การเข้าสู่ระบบ',
  'dvf.chraniB': ': คนที่รู้รหัสผ่านของคุณแต่ไม่มีมือถือของคุณก็เข้าไม่ได้',
  'dvf.nechrani': 'มันไม่ปกป้องข้อความที่เข้ารหัส',
  'dvf.nechraniPopis': ' — ข้อความเหล่านั้นเปิดด้วยรหัสผ่านของคุณในเบราว์เซอร์ของคุณเอง โดยไม่ผ่านเซิร์ฟเวอร์',
  'dvf.ulozKody': 'เก็บรหัสสำรองสิบรหัสนี้ไว้',
  'dvf.ulozKodyPopis1': 'แต่ละรหัสใช้ได้ครั้งเดียว และเป็นทางเดียวที่จะเข้าได้ถ้าคุณทำมือถือหาย',
  'dvf.znovuNeukaze': 'จะไม่มีใครแสดงให้คุณดูอีก',
  'dvf.ulozKodyPopis2': ' — เราเก็บแค่ลายนิ้วมือของมัน',
  'dvf.zkopirovat': 'คัดลอก',
  'dvf.ulozilaJsem': 'ฉันเก็บไว้แล้ว',
  'dvf.zkopirovano': 'คัดลอกแล้ว',
  'dvf.kopieChyba': 'คัดลอกไม่สำเร็จ โปรดจดด้วยมือ',
  'dvf.zapnout': 'เปิดการเข้าสู่ระบบสองขั้นตอน',
  'dvf.pripravuji': 'กำลังเตรียม…',
  'dvf.nactiKod': 'สแกนรหัสนี้ในแอปยืนยันตัวตน — เช่น Google Authenticator, Authy, 1Password หรือ Aegis',
  'dvf.qrNejde': 'สแกนคิวอาร์โค้ดไม่ได้?',
  'dvf.zadejRucne': 'กรอกกุญแจนี้ในแอปด้วยมือ:',
  'dvf.opisKod': 'กรอกรหัสที่แอปแสดง',
  'dvf.zapnoutKratce': 'เปิด',
  'dvf.overuji': 'กำลังตรวจสอบ…',
  'dvf.noveKody': 'รหัสสำรองชุดใหม่',
  'dvf.vypnout': 'ปิด',
  'dvf.noveKodyPopis': 'ชุดใหม่จะแทนชุดเก่า — รหัสสำรองปัจจุบันของคุณจะใช้ไม่ได้อีก',
  'dvf.kodZAplikace': 'รหัสจากแอป',
  'dvf.vygenerovat': 'สร้าง',
  'dvf.vypnutiPopis': 'การปิดต้องใช้ทั้งรหัสผ่านและรหัสที่ยังใช้ได้ ตั้งใจให้เป็นทั้งสองอย่าง มิฉะนั้นใครก็ตามที่เข้าถึงเบราว์เซอร์ที่เปิดค้างไว้ก็ปิดมันได้',
  'dvf.kodNeboZalozni': 'รหัสจากแอปหรือรหัสสำรอง',
  'dvf.vypinam': 'กำลังปิด…',
  'dvf.vypnoutCele': 'ปิดการเข้าสู่ระบบสองขั้นตอน',
  'dvf.vypnuto2': 'ปิดการเข้าสู่ระบบสองขั้นตอนแล้ว',
  'dvf.kodNesedi': 'รหัสนี้ไม่ถูกต้อง',
  'dvf.nepovedlo': 'ไม่สำเร็จ',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'อัปเดตโปรไฟล์แล้ว',
  'pf.chyba': 'อัปเดตโปรไฟล์ไม่สำเร็จ',
  'pf.fotkaNahrana': 'อัปโหลดรูปแล้ว',
  'pf.fotkaChyba': 'อัปโหลดรูปไม่สำเร็จ',
  'pf.fotkaVelka': 'รูปใหญ่เกินไป (สูงสุด 5 MB)',
  'pf.oznameniUlozeno': 'บันทึกการตั้งค่าการแจ้งเตือนแล้ว',
  'pf.oznameniChyba': 'บันทึกการตั้งค่าไม่สำเร็จ',
  'pf.zruseno': 'ลบโปรไฟล์ของคุณแล้ว',
  'pf.zruseniChyba': 'ลบโปรไฟล์ไม่สำเร็จ',
  'pf.zruseniPotvrzeni': 'คุณต้องการลบโปรไฟล์จริง ๆ ใช่ไหม? การนี้ย้อนกลับไม่ได้และข้อมูลทั้งหมดของคุณจะถูกลบ',
  'pf.urlFacebook': 'ที่อยู่ Facebook ต้องขึ้นต้นด้วย https://',
  'pf.urlInstagram': 'ที่อยู่ Instagram ต้องขึ้นต้นด้วย https://',
  'pf.urlLinkedin': 'ที่อยู่ LinkedIn ต้องขึ้นต้นด้วย https://',
  'pf.ukladam': 'กำลังบันทึก…',
  'pf.ulozitOznameni': 'บันทึกการตั้งค่าการแจ้งเตือน',
  'pf.oznameniZpravy': 'ข้อความส่วนตัว',
  'pf.oznameniAdmin': 'ข้อความใหม่จากผู้ดูแล',
  'pf.oznameniUzivatel': 'ข้อความใหม่จากคนอื่น',
  'pf.oznameniPodpora': 'โพสต์ใหม่ในหมวดช่วยเหลือกัน',
  'pf.oznameniNabidky': 'ข้อเสนอและคำขอ',

  // odznaky
  'pf.odznakAdmin': 'ผู้ดูแล',
  'pf.odznakPravnik': 'นักกฎหมาย',
  'pf.odznakSpecialista': 'ผู้เชี่ยวชาญที่ยืนยันแล้ว',
  'pf.odznakClen': 'สมาชิกที่ยืนยันแล้ว',
  'pf.odznakPomocnik': 'ผู้ช่วยที่แข็งขัน',
  'pf.odznakDuveryhodny': 'คนที่ไว้ใจได้',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'เพิ่มรูปลงในแกลเลอรีแล้ว',
  'gal.smazano': 'ลบรูปแล้ว',
  'gal.hesloKratke': 'รหัสผ่านแกลเลอรีต้องมีอย่างน้อย 4 ตัวอักษร',
  'gal.nahraniChyba': 'อัปโหลดรูปไม่สำเร็จ',
  'gal.mazaniChyba': 'ลบรูปไม่สำเร็จ',
  'gal.souborVelky': 'ไฟล์ใหญ่เกินไป (สูงสุด 5 MB)',
  'gal.ulozitNastaveni': 'บันทึกการตั้งค่า',
  'gal.hesloPopis': 'ผู้เข้าชมต้องกรอกรหัสผ่านนี้จึงจะเห็นแกลเลอรี',
  'gal.pridat': 'เพิ่มรูปหรือวิดีโอ',
  'gal.prazdna': 'แกลเลอรียังไม่มีรูป',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'ตอนนี้ฉันอยู่ตรงไหน?',
  'cesta.popis': 'แบ่งปันระยะการข้ามเพศของคุณถ้าต้องการ — หรือเก็บไว้กับตัวเองก็ได้',
  'cesta.soukroma': 'ระยะของคุณเป็นเรื่องส่วนตัว',
  'cesta.viditelna': 'คนอื่นเห็นระยะของคุณ',
  'cesta.jenTy': 'มีแต่คุณที่เห็นระยะของตัวเอง',
  'cesta.mohouNajit': 'คนอื่นหาคุณเจอผ่าน «หาคนที่อยู่ในระยะใกล้เคียง»',
  'cesta.poznamka': 'บันทึกส่วนตัว',
  'cesta.volitelna': '(ไม่บังคับ)',
  'cesta.poznamkaPriklad': 'อะไรก็ตามที่คุณอยากแบ่งปันหรืออยากจำไว้…',
  'cesta.najitPodobne': 'หาคนที่อยู่ในระยะใกล้เคียง',
  'cesta.hledam': 'กำลังค้นหา…',
  'cesta.ulozit': 'บันทึกเส้นทางของฉัน',
  'cesta.ulozeno': 'บันทึกเส้นทางของคุณแล้ว',
  'cesta.vyberteFazi': 'โปรดเลือกระยะหนึ่ง',
  'cesta.chyba': 'บันทึกไม่สำเร็จ',

  'pf.socialniSite': 'โซเชียลมีเดีย',
  'pf.avatarFoto': 'อวาตาร์ / รูปโปรไฟล์',
  'pf.nahratProfilni': 'อัปโหลดรูปโปรไฟล์',
  'pf.zrusitProfil': 'ลบโปรไฟล์',
  'pf.nastaveniOznameni': 'การตั้งค่าการแจ้งเตือน',
  'pf.nastaveniOznameniPopis': 'เลือกว่าคุณอยากได้รับแจ้งเรื่องอะไร',
  'gal.overEmail': 'ก่อนอัปโหลดรูป โปรดยืนยันอีเมลของคุณก่อน',
  'cesta.coMeCeka': 'อะไรรออยู่ข้างหน้า',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'ข้อความ',
  'zpr.hledatUzivatele': 'ค้นหาคน…',
  'zpr.zadneKonverzace': 'ยังไม่มีบทสนทนา',
  'zpr.vyhledejteVyse': 'ค้นหาคนด้านบน',
  'zpr.vyberteKonverzaci': 'เลือกบทสนทนาหรือค้นหาใครสักคน',
  'zpr.napisteZpravu': 'เขียนข้อความ…',
  'zpr.nahravam': 'กำลังบันทึกเสียง…',
  'zpr.prilozitObrazek': 'แนบรูป',
  'zpr.hlasovaZprava': 'ข้อความเสียง',
  'zpr.zastavitNahravani': 'หยุดบันทึกเสียง',
  'zpr.obrazek': 'รูปภาพ',
  'zpr.overteEmail': 'ก่อนส่งข้อความ โปรดยืนยันอีเมลของคุณ',
  'zpr.profil': 'โปรไฟล์',

  // šifrování
  'zpr.sifrovanaZprava': 'ข้อความที่เข้ารหัส',
  'zpr.odemkniNahore': 'ข้อความที่เข้ารหัส — ปลดล็อกข้อความของคุณด้านบน',
  'zpr.nelzeOtevrit': 'เปิดข้อความที่เข้ารหัสนี้ไม่ได้',

  // hlášky
  'zpr.uzivatelNenalezen': 'ไม่พบคนนี้',
  'zpr.prijemceNenalezen': 'ไม่พบผู้รับ',
  'zpr.prihlasteZnovu': 'โปรดเข้าสู่ระบบใหม่ (เซสชันหมดอายุ)',
  'zpr.serverNedostupny': 'ติดต่อเซิร์ฟเวอร์ไม่ได้ ตรวจดูว่าแบ็กเอนด์ทำงานอยู่หรือไม่',
  'zpr.chybaOdeslani': 'ส่งไม่สำเร็จ',
  'zpr.souborVelky': 'ไฟล์ใหญ่เกินไป (สูงสุด 5 MB)',
  'zpr.formatNepodporovan': 'ไม่รองรับไฟล์ชนิดนี้',
  'zpr.mediaOdeslano': 'ส่งไฟล์แล้ว',
  'zpr.mikrofon': 'ใช้ไมโครโฟนไม่ได้',
  'zpr.hlasovkaOdeslana': 'ส่งข้อความเสียงแล้ว',
  'zpr.hlasovkaChyba': (p) => `ส่งข้อความเสียงไม่สำเร็จ: ${p.detail}`,
  'zpr.smazano': 'ลบบทสนทนาแล้ว',
  'zpr.smazaniChyba': 'ลบบทสนทนาไม่สำเร็จ',
  'zpr.smazaniPotvrzeni': 'มันจะหายจากรายการของคุณ พร้อมไฟล์แนบ อีกฝ่ายยังเก็บสำเนาของเขาไว้ — '
      + 'ข้อความจะถูกลบออกจากเซิร์ฟเวอร์จริง ๆ ก็ต่อเมื่อทั้งสองฝ่ายลบ',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'โปรดกรอกรหัสผ่านของคุณ',
  'sif.zapnuto': 'การเข้ารหัสเปิดอยู่',
  'sif.odemceno': 'ข้อความของคุณถูกปลดล็อกแล้ว',
  'sif.hesloNesedi': 'รหัสผ่านนี้ไม่ถูกต้อง',
  'sif.prohlizecNeumi': 'เบราว์เซอร์นี้ไม่รองรับการเข้ารหัสที่ Bloom ใช้ คุณยังเขียนข้อความได้ '
      + 'แต่จะไม่ถูกเข้ารหัสแบบต้นทางถึงปลายทาง',
  'sif.noveJsouSifrovane': 'ข้อความใหม่ถูกเข้ารหัส มีแต่คุณที่ถือกุญแจ — เซิร์ฟเวอร์อ่านไม่ได้',
  'sif.odemkniZpravy': 'ปลดล็อกข้อความของคุณ',
  'sif.odemkniPopis': 'กุญแจอยู่แค่ในหน่วยความจำของแท็บนี้ หลังโหลดหน้าใหม่จึงต้องกรอกรหัสผ่านอีกครั้ง '
      + 'เราเก็บมันไว้ที่ไหนไม่ได้ — ถ้าเก็บได้ มันก็จะไม่ใช่การเข้ารหัสที่คุณคุมคนเดียวอีกต่อไป',
  'sif.zapniSifrovani': 'เปิดการเข้ารหัสข้อความ',
  'sif.zapniPopis': 'ข้อความใหม่ถูกเข้ารหัสตรงนี้ บนอุปกรณ์ของคุณ เซิร์ฟเวอร์ได้รับแค่ตัวอักษรที่อ่านไม่ออก '
      + 'และอ่านมันไม่ได้ — แม้ศาลจะสั่งก็ตาม',
  'sif.pozorA': 'ระวัง: กุญแจเปิดด้วยรหัสผ่านของคุณ',
  'sif.pozorTucne': 'ถ้าคุณลืมมัน ไม่มีใครอ่านข้อความที่เข้ารหัสของคุณได้',
  'sif.pozorB': ' — เราก็ไม่ได้ นั่นคือประเด็นทั้งหมด แต่หมายความว่าคุณต้องมีที่เก็บมันไว้',
  'sif.mobilA': 'การเปิดใช้ยังเปลี่ยนวิธีเข้าสู่ระบบด้วย รหัสผ่านของคุณจะไม่ไปถึงเซิร์ฟเวอร์อีกเลย ส่งไปแค่ลายนิ้วมือของมัน',
  'sif.mobilTucne': 'แอปมือถือ Bloom รุ่นเก่าจะเข้าสู่ระบบบัญชีนี้ไม่ได้',
  'sif.mobilB': ' จนกว่าเราจะอัปเดตมัน บนเว็บทุกอย่างยังทำงานตามปกติ',
  'sif.zapnoutSifrovani': 'เปิดการเข้ารหัส',
  'sif.odemknout': 'ปลดล็อก',
  'sif.tvojeHeslo': 'รหัสผ่าน Bloom ของคุณ',
  'sif.prilohaZamcena': 'ไฟล์แนบที่เข้ารหัส — ปลดล็อกข้อความของคุณด้านบน',
  'sif.prilohaChyba': 'เปิดไฟล์แนบไม่ได้',
  'sif.priloha': 'ไฟล์แนบของข้อความ',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'ตำแหน่งของคุณ',
  'okoli.nastavtePolohu': 'บอกว่าคุณอยู่ที่ไหน เพื่อให้เห็นผลลัพธ์ที่ใกล้ตัว',
  'okoli.vyberteVyse': 'เลือกสถานที่ด้านบนเพื่อดูข้อเสนอและผู้เชี่ยวชาญใกล้คุณ',
  'okoli.zadniOdbornici': 'ในพื้นที่นี้ยังไม่มีผู้เชี่ยวชาญลงทะเบียน',
  'okoli.zadneNabidky': 'ในพื้นที่นี้ยังไม่มีข้อเสนอ',
  'okoli.zadniClenove': 'ในพื้นที่นี้ยังไม่มีใครจากชุมชน',
  'okoli.vytvoritNabidku': 'สร้างข้อเสนอ',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'กำลังค้นหา:',
  'hled.vysledkyPro': 'ผลการค้นหา:',
  'hled.nicPro': 'เราไม่พบอะไรสำหรับ:',
  'hled.nicZkuste': 'เราไม่พบอะไรเลย ลองคำอื่นดู',
  'hled.zkratte': 'ลองใช้วลีสั้นลงหรือคำค้นอื่น',
  'hled.zadejte': 'พิมพ์สิ่งที่คุณหาแล้วกด Enter',
  'hled.priklady': 'เช่น FFS, ฮอร์โมน, ชื่อ, แพทย์, เอกสาร, ผ่าตัด…',
  'hled.uzivatele': 'ผู้คน',
  'hled.odbornici': 'ผู้เชี่ยวชาญที่เป็นมิตรกับคนข้ามเพศ',
  'hled.clanky': 'ความช่วยเหลือทางกฎหมาย – บทความ',
  'hled.otazky': 'คำถามของชุมชน',
  'hled.nabidky': 'ข้อเสนอช่วยเหลือ',
  'hled.prispevky': 'โพสต์',
  'hled.recenze': 'รีวิวผู้เชี่ยวชาญ',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'ไม่พบคนนี้',
  'up.oMne': 'เกี่ยวกับ',
  'up.clenOd': 'อยู่ใน Bloom ตั้งแต่',
  'up.odznakSpravce': 'ผู้ดูแล',
  'up.odznakPravnik': 'นักกฎหมาย',
  'up.odznakOdbornik': 'ผู้เชี่ยวชาญที่ยืนยันแล้ว',
  'up.odznakPravnikOvereny': 'นักกฎหมายที่ยืนยันแล้ว',
  'up.odznakClen': 'สมาชิกที่ยืนยันแล้ว',
  'up.odznakPomocnik': 'ผู้ช่วยที่แข็งขัน',
  'up.odznakDuveryhodny': 'ไว้ใจได้',
  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'กลับไปที่ Bloom',
  'kom.oProjektu': 'Bloom เกิดขึ้นเป็นพื้นที่ชุมชนที่ปลอดภัยสำหรับคนข้ามเพศในเช็กเกีย — ที่ที่ '
      + 'ได้แบ่งปันประสบการณ์ หาการสนับสนุน เข้าถึงผู้เชี่ยวชาญ และรู้จักคนอื่น ๆ '
      + 'โครงการนี้ดูแลโดยชุมชนเองด้วยความสมัครใจ เป้าหมายคือความเป็นส่วนตัว ความรอบคอบ และการช่วยเหลือกัน',
  'kom.kontaktText': 'มีคำถามหรือต้องการความช่วยเหลือ? ติดต่อมาได้เลย เราพยายามตอบให้เร็วที่สุด',
  'kom.respekt': 'เราเคารพกัน',
  'kom.respektPopis': 'เราเรียกทุกคนด้วยชื่อและคำสรรพนามที่เขาใช้ เราเคารพเส้นทางและประสบการณ์ที่ต่างกัน — '
      + 'ไม่มีวิธีถูกหรือผิดในการเป็นคนข้ามเพศ',
  'kom.soukromi': 'เราปกป้องความเป็นส่วนตัวของกันและกัน',
  'kom.soukromiPopis': 'สิ่งที่แบ่งปันใน Bloom ให้อยู่ใน Bloom อย่าแบ่งปันข้อมูลของคนอื่นโดย '
      + 'ไม่ได้รับความยินยอม เราเคารพการไม่เปิดเผยตัวตน',
  'kom.pomahame': 'เราช่วยเหลือกัน',
  'kom.pomahamePopis': 'Bloom คือเรื่องของการช่วยเหลือกัน เราแบ่งปันประสบการณ์ ช่วยกัน และสร้างพื้นที่ปลอดภัย '
      + 'สำหรับทุกคนที่กำลังหาการเชื่อมโยงหรือข้อมูล',
  'kom.obtezovani': 'เราไม่ยอมให้มีการคุกคาม',
  'kom.obtezovaniPopis': 'การคุกคาม การกลั่นแกล้ง หรือความเห็นที่ก้าวร้าวไม่มีที่ยืนใน Bloom ถ้าคุณรู้สึกไม่สบายใจ '
      + 'เขียนถึงผู้ดูแลได้',
  'kom.spam': 'ไม่มีสแปมและโฆษณา',
  'kom.spamPopis': 'Bloom ไม่ใช่ตลาด อย่าโพสต์โฆษณาที่ไม่ได้ร้องขอหรือเนื้อหาเชิงพาณิชย์ '
      + 'ข้อเสนอและคำขออยู่ในหมวดช่วยเหลือกัน',
  'kom.prostor': 'พื้นที่สำหรับทุกระยะ',
  'kom.prostorPopis': 'คุณไม่ได้อยู่คนเดียว ไม่ว่าคุณจะอยู่ตรงไหนของเส้นทาง เรายินดีต้อนรับทั้งคนที่กำลังคิด '
      + 'เรื่องการข้ามเพศ คนที่อยู่ระหว่างทาง และคนที่ผ่านมาแล้ว — และรับทุกเส้นทางอย่างที่มันเป็น',
  'kom.dataPopis': 'Bloom เก็บเฉพาะข้อมูลที่แพลตฟอร์มต้องใช้เพื่อทำงาน: อีเมล ชื่อเล่น และโปรไฟล์ '
      + 'ที่คุณสร้างเอง',
  'kom.dataTretiStrany': 'ข้อมูลของคุณไม่ถูกส่งต่อให้บุคคลที่สาม แพลตฟอร์มไม่ใช้เทคโนโลยีติดตามและไม่ใช้เครือข่ายโฆษณา',
  'kom.dataSmazani': 'คุณมีสิทธิ์ขอให้ลบบัญชีและข้อมูลทั้งหมดที่เกี่ยวข้อง ติดต่อผู้ดูแลได้',

  'okoli.podtitulek': 'หาคนในชุมชน บริการ และผู้เชี่ยวชาญใกล้คุณ',
  'okoli.cleneVOkoli': (p) => `คนในชุมชนใกล้ ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `ข้อเสนอช่วยเหลือใกล้ ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `ผู้เชี่ยวชาญใกล้ ${p.misto}`,
  'hled.zobrazitVice': 'ดูเพิ่ม',
  'kom.titulek': 'หลักปฏิบัติของชุมชน',
  'kom.podtitulek': 'พื้นที่ปลอดภัยสำหรับทุกคน',
  'kom.jakNahlasit': 'วิธีแจ้งปัญหา',
  'kom.jakNahlasitPopis': 'ถ้าคุณเจอพฤติกรรมที่ไม่เหมาะสม มีสองทาง: ใช้ปุ่ม «รายงานคนนี้» '
      + 'ในโปรไฟล์ของเขา หรือเขียนถึงผู้ดูแล',
  'kom.duverne': 'การรายงานของคุณเป็นความลับ',
  'kom.ochranaSoukromi': 'ความเป็นส่วนตัว',
  'obecne.zpetKratce': 'กลับ',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'ยังไม่มีใครในชุมชนแสดงระยะนี้เป็นสาธารณะ',
  'cesta.poznamkaFazePriklad': 'อะไรก็ตามที่คุณอยากแบ่งปันหรืออยากจำไว้เกี่ยวกับระยะนี้…',
  'pruvodce.fazeNenalezena': 'ไม่พบระยะนี้',
  'pruvodce.pripravujeme': 'ส่วนนี้เรากำลังเตรียมอยู่',
  'pruvodce.krokyJenTy': 'ขั้นตอนที่คุณติ๊กไว้ มีแต่คุณที่เห็น',
  'pruvodce.nastavitFazi': 'ตั้งเป็นระยะปัจจุบันของฉัน',
  'pruvodce.fazeNastavena': 'ตั้งเป็นระยะปัจจุบันของคุณแล้ว',
  'pruvodce.chyba': 'บันทึกไม่สำเร็จ ลองอีกครั้ง',
  'pruvodce.kroku': 'ขั้นตอน',
  'pruvodce.odborniku': () => 'ผู้เชี่ยวชาญสำหรับระยะนี้',
  'pruvodce.pribehu': () => 'เรื่องราวจากคนในระยะนี้',

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'ตั้งรหัสผ่านใหม่',
  'reset.popis': 'กรอกรหัสผ่านใหม่สำหรับบัญชี Bloom ของคุณ',
  'reset.noveHeslo': 'รหัสผ่านใหม่',
  'reset.noveHesloPriklad': 'กรอกรหัสผ่านใหม่',
  'reset.potvrdit': 'ยืนยันรหัสผ่านใหม่',
  'reset.nastavit': 'บันทึกรหัสผ่านใหม่',
  'reset.ukladam': 'กำลังบันทึก…',
  'reset.hotovo': 'เปลี่ยนรหัสผ่านของคุณแล้ว ตอนนี้เข้าสู่ระบบได้',
  'reset.neplatnyOdkaz': 'ลิงก์ตั้งรหัสผ่านใหม่นี้ใช้ไม่ได้',
  'reset.odkazVyprsel': 'ลิงก์หมดอายุหรือใช้ไม่ได้ โปรดขอลิงก์ใหม่',
  'reset.chyba': 'ตั้งรหัสผ่านใหม่ไม่สำเร็จ',
  'reset.neshoda': 'รหัสผ่านไม่ตรงกัน',
  'reset.ztratiPristup': 'จะเสียการเข้าถึง',

  'cesta.volitelne': 'เรื่องนี้เป็นความสมัครใจล้วน ๆ แบ่งปันระยะการข้ามเพศของคุณถ้าต้องการ — หรือเก็บไว้กับตัวเอง '
      + 'คุณยังหาคนที่อยู่ในจุดใกล้เคียงกันบนเส้นทางได้ด้วย',
  'cesta.hledatVeFazi': 'หาคนในระยะนี้:',
  'cesta.jenVerejne': '(เฉพาะคนที่แสดงเป็นสาธารณะ)',
  'pruvodce.zpetNaCestu': 'กลับไปที่เส้นทางของฉัน',
  'pruvodce.tadyJsi': 'ตอนนี้คุณอยู่ตรงนี้',
  'reset.prejitNaPrihlaseni': 'ไปหน้าเข้าสู่ระบบ',
  'reset.sifrovaniVarovani': 'ถ้าคุณเปิดการเข้ารหัสข้อความไว้: การตั้งรหัสผ่านใหม่หมายความว่าคุณจะเข้าถึงข้อความ '
      + 'ที่เข้ารหัสเก่าไม่ได้อีก กุญแจของมันเปิดด้วยรหัสผ่านเดิม ซึ่งที่นี่ไม่มีใครรู้ จึงห่อใหม่ไม่ได้ '
      + 'ข้อความใหม่ยังเข้ารหัสได้ต่อไป แต่ข้อความเก่าจะไม่มีใครอ่านได้ — รวมถึงเราด้วย',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'เข้าสู่ระบบ',
  'uvod.vytvoritUcet': 'สร้างบัญชี',
  'uvod.uzMamUcet': 'ฉันมีบัญชีอยู่แล้ว',
  'uvod.nadpis': 'พื้นที่ปลอดภัยสำหรับชุมชนคนข้ามเพศ',
  'uvod.podnadpis': 'Bloom คือที่ส่วนตัวที่คุณพูดได้อย่างเปิดใจ หาผู้เชี่ยวชาญที่เป็นมิตร '
      + 'และเดินผ่านการข้ามเพศท่ามกลางคนที่เข้าใจว่ามันเป็นอย่างไร',
  'uvod.zdarma': 'สมัครฟรี เนื้อหาของ Bloom จะเปิดหลังเข้าสู่ระบบเท่านั้น',
  'uvod.kCemuJe': 'Bloom มีไว้ทำอะไร',
  'uvod.kCemuJe1': 'การหาข้อมูลเรื่องการข้ามเพศในเช็กเกียมักหมายถึงการคลิกไปตามกระดานสนทนา '
      + 'ที่กระจัดกระจาย บทความเก่า และลิงก์ที่ไม่รู้ว่าจะเชื่อใครดี และหลายคำถาม '
      + 'คนที่เคยผ่านมาเองก็ตอบได้ดีที่สุดอยู่ดี',
  'uvod.kCemuJe2': 'Bloom รวมทุกอย่างไว้ที่เดียว: ผู้เชี่ยวชาญที่ชุมชนมีประสบการณ์ดีด้วย คู่มือ '
      + 'ตลอดระยะต่าง ๆ ของการข้ามเพศ ความช่วยเหลือทางกฎหมาย และเหนือสิ่งอื่นใดคือคนที่คุณเขียนถึงได้',
  'uvod.kCemuJe3': 'และเพราะนี่เป็นเรื่องที่ไม่มีใครอยากเล่าให้ทั้งอินเทอร์เน็ตฟัง Bloom จึงถูกสร้างขึ้น '
      + 'ตั้งแต่ต้นให้มองจากข้างนอกไม่เห็นอะไรเลย',
  'uvod.coNajdes': 'คุณจะพบอะไรใน Bloom',
  'uvod.coNajdesPopis': 'แปดส่วนที่ต่อเนื่องกัน — ตั้งแต่ความช่วยเหลือที่ใช้ได้จริงจนถึงประสบการณ์ที่แบ่งปันกัน',
  'uvod.soukromiZaklad': 'ความเป็นส่วนตัวไม่ใช่ของแถม แต่เป็นรากฐาน',
  'uvod.jakZabezpeceny': 'Bloom ปลอดภัยอย่างไร',
  'uvod.zabezpeceniPopis': 'ข้อมูลของสมาชิกไม่ถูกขายหรือนำไปวิเคราะห์ที่ไหนทั้งนั้น ใน Bloom ไม่มีการติดตาม '
      + 'เพื่อโฆษณาหรือเพื่อวิเคราะห์ใด ๆ — ไม่มีสคริปต์ภายนอกที่รู้อะไรเกี่ยวกับคุณ',
  'uvod.coNeumi': 'สิ่งที่ Bloom ทำไม่ได้',
  'uvod.metadataTucne': 'ใครเขียนถึงใครและเมื่อไร',
  'uvod.coNeumiA': 'เซิร์ฟเวอร์รู้เสมอว่า',
  'uvod.coNeumiB': ' — ถ้าไม่รู้ก็ส่งข้อความไม่ได้ ข้อมูลกำกับนี้การเข้ารหัสต้นทางถึงปลายทางก็ซ่อนไม่ได้ '
      + 'Signal ก็เช่นกัน โปรไฟล์เข้ารหัสไม่ได้ เพราะเซิร์ฟเวอร์ต้องแสดงให้คนอื่นเห็น '
      + 'และเพราะ Bloom เป็นเว็บแอป มันจึงดาวน์โหลดโค้ดเข้ารหัสจากเซิร์ฟเวอร์ของเราทุกครั้งที่เปิด — '
      + 'ใครยึดเซิร์ฟเวอร์ได้ในทางทฤษฎีก็อาจยัดโค้ดที่แก้ไขแล้วมาได้ '
      + 'สิ่งที่ป้องกันได้มีเพียงแอปที่เซ็นรับรองจากสโตร์',
  'uvod.pridejSe': 'มาร่วมกับเรา',
  'uvod.pridejSePopis': 'แค่ชื่อเล่นกับอีเมลก็พอ — คุณไม่ต้องบอกชื่อตามกฎหมายที่ไหนเลย สิ่งที่คุณเขียน '
      + 'เกี่ยวกับตัวเองขึ้นอยู่กับคุณ และแก้หรือลบเมื่อไรก็ได้',

  // co Bloom nabízí
  'uvod.karta.podpora': 'เสนอความช่วยเหลือหรือขอความช่วยเหลือ — ตั้งแต่ไปเป็นเพื่อนหาหมอ ให้ยืมเสื้อผ้า จนถึง '
      + '«ฉันอยากคุยกับใครสักคน»',
  'uvod.karta.odbornici': 'เพศศาสตร์ ต่อมไร้ท่อ ศัลยกรรม จิตบำบัด และร้านทำผม พร้อมแผนที่ ผู้ติดต่อ และประสบการณ์ของคนอื่น',
  'uvod.karta.pravo': 'การเปลี่ยนชื่อ เอกสารราชการ งาน โรงเรียน ตอบโดยคนที่รู้เรื่องจริง',
  'uvod.karta.pruvodce': 'แต่ละขั้นตอนจะเป็นอย่างไร — ตั้งแต่คำถามแรกจนถึงการผ่าตัด พร้อมลิงก์ไปยังแหล่งข้อมูลและผู้เชี่ยวชาญที่ตรวจสอบแล้ว',
  'uvod.karta.zpravy': 'เขียนถึงใครก็ได้ในชุมชน ข้อความและไฟล์แนบถูกเก็บบนเซิร์ฟเวอร์แบบเข้ารหัส',
  'uvod.karta.zkusenosti': 'เรื่องจริงจากคนที่ผ่านมาแล้ว ไม่มีการเซ็นเซอร์และไม่มีการตกแต่ง',
  'uvod.karta.aktuality': 'อะไรกำลังเกิดขึ้นรอบประเด็นคนข้ามเพศในเช็กเกีย — การเปลี่ยนกฎหมาย กิจกรรม ข่าวจากชุมชน',
  'uvod.karta.okoli': 'ใครอยู่ใกล้คุณ เพื่อให้คุณรู้ว่าคุณไม่ได้อยู่คนเดียว แม้ในเมืองเล็ก ๆ',

  // zabezpečení
  'uvod.bezp.zvencinic': 'จากข้างนอกมองไม่เห็นอะไรเลย',
  'uvod.bezp.zvencinicText': 'โปรไฟล์ เรื่องราว รูปภาพ ข้อเสนอ และรูปในโพสต์ ต้องเข้าสู่ระบบก่อน ถ้าไม่มีบัญชี '
      + 'เซิร์ฟเวอร์จะไม่ให้ข้อมูลใด ๆ เกี่ยวกับสมาชิก — แม้แต่กับเสิร์ชเอนจิน',
  'uvod.bezp.hesla': 'ไม่มีใครรู้รหัสผ่านของคุณ',
  'uvod.bezp.heslaText': 'ระบบเก็บเพียงลายนิ้วมือ bcrypt ซึ่งคำนวณย้อนกลับเป็นรหัสผ่านเดิมไม่ได้ แม้แต่ '
      + 'ผู้ดูแลก็ไม่เห็นรหัสผ่านของคุณและส่งให้คุณไม่ได้ — ทำได้แค่ให้คุณตั้งรหัสใหม่',
  'uvod.bezp.sifrovani': 'ข้อความถูกเข้ารหัสจากคุณถึงอีกฝ่าย',
  'uvod.bezp.sifrovaniText': 'เมื่อคุณเปิดการเข้ารหัสต้นทางถึงปลายทาง ข้อความและไฟล์แนบจะถูกเข้ารหัสในเบราว์เซอร์ของคุณเอง '
      + 'กุญแจเปิดด้วยรหัสผ่านของคุณและไม่เคยออกจากอุปกรณ์ของคุณ — เซิร์ฟเวอร์ได้รับแค่ '
      + 'ตัวอักษรที่อ่านไม่ออกและอ่านไม่ได้ แม้ศาลจะสั่งก็ตาม ถ้าไม่เปิดการเข้ารหัส ข้อความก็ยังถูก '
      + 'เข้ารหัสบนดิสก์ของเซิร์ฟเวอร์อยู่ดี',
  'uvod.bezp.kontakty': 'ข้อมูลติดต่อของคุณยังเป็นของคุณ',
  'uvod.bezp.kontaktyText': 'อีเมลและเบอร์โทรของคุณไม่เคยถูกส่งให้สมาชิกคนอื่น ระยะการข้ามเพศของคุณเป็นเรื่องส่วนตัวจนกว่า '
      + 'คุณจะเผยแพร่เอง — และขั้นตอนที่คุณติ๊กในคู่มือ มีแต่คุณที่เห็น',
  'uvod.bezp.smazane': 'ลบแล้วคือลบจริง ๆ',
  'uvod.bezp.smazaneText': 'คุณลบบทสนทนาได้ทุกเมื่อ เมื่อทั้งสองฝ่ายลบ มันจะหายจากเซิร์ฟเวอร์ '
      + 'อย่างถาวร พร้อมไฟล์แนบ',
  'uvod.bezp.server': 'เซิร์ฟเวอร์ของเราเองในยุโรป',
  'uvod.bezp.serverText': 'Bloom ทำงานบนเซิร์ฟเวอร์ของเราเองในสหภาพยุโรป ผ่าน HTTPS เท่านั้น ฐานข้อมูลเข้าถึงจาก '
      + 'อินเทอร์เน็ตไม่ได้ ข้อมูลสำรองถูกเข้ารหัสและส่งไปเก็บที่อื่น และทดสอบการกู้คืนแล้ว',

  'uvod.karta.pruvodceNazev': 'คู่มือการข้ามเพศ',
  'uvod.karta.zpravyNazev': 'ข้อความส่วนตัว',
  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'เสนอสิ่งที่คุณทำได้ และรับความช่วยเหลือจากคนอื่นในชุมชน',
  'pod.vse': 'ทั้งหมด',
  'pod.nabidky': 'ข้อเสนอ',
  'pod.poptavky': 'คำขอ',
  'pod.nabidka': 'ข้อเสนอ',
  'pod.poptavka': 'คำขอ',
  'pod.celaCR': 'ทั่วเช็กเกีย',
  'pod.celySvet': 'ทั้งโลก',
  'pod.cesko': 'เช็กเกีย',
  'pod.svet': 'โลก',
  'pod.vsechnyTypy': 'ทุกหมวดหมู่',
  'pod.moje': (p) => `ของฉัน (${p.pocet})`,
  'pod.pridat': 'เพิ่ม',
  'pod.overEmail': 'ยืนยันอีเมลเพื่อเพิ่มข้อเสนอ',
  'pod.novaPoptavka': 'คำขอใหม่',
  'pod.novaNabidka': 'ข้อเสนอใหม่',
  'pod.popisPoptavky': 'เขียนว่าคุณกำลังหาอะไรและคุณให้อะไรตอบแทนได้',
  'pod.popisNabidky': 'เสนอสิ่งที่คุณทำได้ให้คนอื่นในชุมชน',
  'pod.typPrispevku': 'ประเภทโพสต์',
  'pod.volitelne': '(ไม่บังคับ)',
  'pod.coNabizim': 'ฉันเสนออะไร',
  'pod.coNabizimP': 'ฉันเสนออะไร *',
  'pod.coHledamP': 'ฉันกำลังหาอะไร *',
  'pod.coHledamVymenou': 'ฉันอยากได้อะไรตอบแทน',
  'pod.priklOffer': 'เช่น ทำอาหาร ทำผม แปลภาษา…',
  'pod.priklNeed': 'เช่น นวด ถ่ายรูป…',
  'pod.poptavkaSeZobrazi': 'คำขอของคุณจะปรากฏในแท็บคำขอ',
  'pod.nabidkaSeZobrazi': 'ถ้าคุณกรอกช่องนี้ ข้อเสนอของคุณจะปรากฏในแท็บคำขอด้วย',
  'pod.popis': 'คำอธิบาย',
  'pod.popisPriklad': 'คำอธิบายที่ละเอียดขึ้น…',
  'pod.oblast': 'พื้นที่',
  'pod.lokalita': 'สถานที่',
  'pod.nechciUvadet': 'ขอไม่ระบุ',
  'pod.kategorie': 'หมวดหมู่',
  'pod.ostatni': 'อื่น ๆ',
  'pod.pridatPoptavku': 'เพิ่มคำขอ',
  'pod.pridatNabidku': 'เพิ่มข้อเสนอ',
  'pod.odpovedetNaPrispevek': 'ตอบโพสต์',
  'pod.napisteAutorovi': 'เขียนข้อความส่วนตัวถึงคนที่โพสต์',
  'pod.od': (p) => `จาก: ${p.kdo}`,
  'pod.odeslatZpravu': 'ส่งข้อความ',
  'pod.konceptOdpovedi': (p) => `สวัสดี! ฉันสนใจ${p.co} «${p.nazev}» ของคุณ `,
  'pod.konceptPoptavka': 'คำขอ',
  'pod.konceptNabidka': 'ข้อเสนอ',
  'pod.zadneMoje': 'คุณยังไม่มีโพสต์',
  'pod.zadneNalezeny': 'ไม่พบโพสต์',
  'pod.vytvortePrvni': 'สร้างข้อเสนอหรือคำขอแรกของคุณ',
  'pod.zkusteFiltry': 'ลองเปลี่ยนตัวกรองหรือเพิ่มโพสต์ใหม่',
  'pod.expirovano': 'หมดอายุ',
  'pod.hledam': 'ฉันกำลังหา',
  'pod.hledamCo': (p) => `ฉันกำลังหา: ${p.co}`,
  'pod.nabizimCo': (p) => `ฉันเสนอ: ${p.co}`,
  'pod.expirovala': 'ข้อเสนอนี้หมดอายุแล้ว ติดต่อผู้ดูแลเพื่อต่ออายุ',
  'pod.odpovedet': 'ตอบ',
  'pod.upravitPrispevek': 'แก้ไขโพสต์',
  'pod.upravtePrispevek': 'แก้ไขข้อเสนอหรือคำขอของคุณ',
  'pod.nabizimP': 'ฉันเสนอ *',
  'pod.hledamPotrebuji': 'ฉันหา / ฉันต้องการ',
  'pod.coNabizitePriklad': 'คุณเสนออะไร…',
  'pod.coHledatePriklad': 'คุณกำลังหาอะไร…',
  'pod.ulozitZmeny': 'บันทึกการเปลี่ยนแปลง',
  'pod.vytvorenoPoptavka': 'สร้างคำขอแล้ว',
  'pod.vytvorenoNabidka': 'สร้างข้อเสนอแล้ว',
  'pod.chybaVytvorit': 'สร้างโพสต์ไม่สำเร็จ',
  'pod.opravduSmazat': 'ลบข้อเสนอนี้?',
  'pod.smazano': 'ลบแล้ว',
  'pod.chybaSmazat': 'ลบไม่สำเร็จ',
  'pod.aktualizovano': 'อัปเดตโพสต์แล้ว',
  'pod.chybaUlozit': 'บันทึกไม่สำเร็จ',
  'pod.zpravaOdeslana': 'ส่งข้อความแล้ว',
  'pod.chybaOdeslat': 'ส่งข้อความไม่สำเร็จ',
  'obecne.hledatPriklad': 'ค้นหา…',
  'obecne.upravit': 'แก้ไข',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'หาผู้เชี่ยวชาญที่ผ่านการตรวจสอบ ซึ่งช่วยคุณบนเส้นทางนี้ได้',
  'odb.hledatPriklad': 'ค้นหาตามชื่อหรือเมือง…',
  'odb.vsechnyObory': 'ทุกสาขา',
  'odb.radit': 'เรียงลำดับ:',
  'odb.vychozi': 'ค่าเริ่มต้น',
  'odb.nejvyssiHodnoceni': '★ คะแนนสูงสุด',
  'odb.nejnizsiHodnoceni': '★ คะแนนต่ำสุด',
  'odb.zadniNalezeni': 'ไม่พบผู้เชี่ยวชาญ',
  'odb.zkusteFiltry': 'ลองเปลี่ยนตัวกรอง',
  'odb.recenzi': () => 'รีวิว',
  'odb.dostupnyV': 'ให้บริการที่:',
  'odb.otevritVMapach': 'เปิดในแผนที่',
  'odb.pridatRecenzi': 'เพิ่มรีวิว',
  'odb.ohodnotte': 'ให้คะแนนประสบการณ์ของคุณกับคนนี้',
  'odb.vaseHodnoceni': 'คะแนนของคุณ *',
  'odb.popisZkusenosti': 'อธิบายประสบการณ์ของคุณ',
  'odb.popisteZkusenost': 'อธิบายประสบการณ์ของคุณ…',
  'odb.odeslatRecenzi': 'ส่งรีวิว',
  'odb.recenze': (p) => `รีวิว (${p.pocet})`,
  'odb.zadneRecenze': 'ยังไม่มีรีวิว เป็นคนแรกสิ',
  'odb.vyberteOdbornika': 'เลือกผู้เชี่ยวชาญเพื่อดูรายละเอียดและแผนที่',
  'odb.pridatOdbornika': 'เพิ่มผู้เชี่ยวชาญ',
  'odb.pridejteOdbornika': 'เพิ่มผู้เชี่ยวชาญที่ตรวจสอบแล้วเข้าในรายการ',
  'odb.navrhnout': 'เสนอผู้เชี่ยวชาญ',
  'odb.navrhnetePopis': 'เสนอผู้เชี่ยวชาญให้ผู้ดูแลอนุมัติ',
  'odb.navrhVysvetleni': 'ข้อเสนอของคุณจะถูกส่งไปยังผู้ดูแล เมื่ออนุมัติแล้วจะปรากฏในรายการ',
  'odb.overEmail': 'ยืนยันอีเมลเพื่อเสนอผู้เชี่ยวชาญ',
  'odb.jmeno': 'ชื่อ *',
  'odb.kategorie': 'หมวดหมู่ *',
  'odb.popis': 'คำอธิบาย',
  'odb.popisPriklad': 'ความเชี่ยวชาญ ประสบการณ์…',
  'odb.adresa': 'ที่อยู่ *',
  'odb.mesto': 'เมือง *',
  'odb.kraj': 'ภูมิภาค',
  'odb.vyber': 'เลือก',
  'odb.stat': 'ประเทศ',
  'odb.cesko': 'เช็กเกีย',
  'odb.telefon': 'โทรศัพท์',
  'odb.web': 'เว็บไซต์',
  'odb.odesilam': 'กำลังส่ง…',
  'odb.odeslatKeSchvaleni': 'ส่งเพื่ออนุมัติ',
  'odb.recenzePridana': 'เพิ่มรีวิวแล้ว',
  'odb.chybaRecenze': 'เพิ่มรีวิวไม่สำเร็จ',
  'odb.odeslanKeSchvaleni': 'ส่งข้อเสนอเพื่ออนุมัติแล้ว',
  'odb.chybaOdeslat': 'ส่งไม่สำเร็จ',
  'odb.pridan': 'เพิ่มผู้เชี่ยวชาญแล้ว',
  'odb.chybaPridat': 'เพิ่มไม่สำเร็จ',
  'odb.polozitOtazku': 'ถามคำถาม',
  'odb.novaOtazka': 'คำถามใหม่ถึงผู้เชี่ยวชาญ',
  'odb.naCoSeZeptat': 'คุณอยากถามผู้เชี่ยวชาญเรื่องอะไร?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'ข้อมูลและการสนับสนุนสำหรับชุมชนคนข้ามเพศ',
  'prav.zpetNaPoradnu': 'กลับไปที่ความช่วยเหลือทางกฎหมาย',
  'prav.clankyAPruvodci': 'บทความและคู่มือ',
  'prav.pridatClanek': 'เพิ่มบทความ',
  'prav.novyClanek': 'บทความใหม่',
  'prav.vytvorteClanek': 'เขียนบทความใหม่สำหรับส่วนกฎหมาย',
  'prav.nazev': 'ชื่อเรื่อง *',
  'prav.kategorie': 'หมวดหมู่',
  'prav.publikovatIhned': 'เผยแพร่ทันที',
  'prav.publikovano': 'เผยแพร่แล้ว',
  'prav.obsah': 'เนื้อหา *',
  'prav.obsahPriklad': 'เนื้อหาบทความ…',
  'prav.zadneClanky': 'ไม่มีบทความในหมวดหมู่นี้',
  'prav.skryto': 'ซ่อนอยู่',
  'prav.skryt': 'ซ่อน',
  'prav.publikovat': 'เผยแพร่',
  'prav.upravitClanek': 'แก้ไขบทความ',
  'prav.upravteObsah': 'แก้ไขเนื้อหาของบทความนี้',
  'prav.clanekPridan': 'เพิ่มบทความแล้ว',
  'prav.chybaPridat': 'เพิ่มบทความไม่สำเร็จ',
  'prav.clanekUpraven': 'อัปเดตบทความแล้ว',
  'prav.opravduSmazat': 'ลบบทความนี้?',
  'prav.chybaStav': 'เปลี่ยนสถานะไม่สำเร็จ',
  'prav.pridatOtazku': 'เพิ่มคำถาม',
  'prav.novaOtazka': 'คำถามใหม่',
  'prav.naCoSeZeptat': 'คุณอยากถามอะไร?',
  'obecne.vse': 'ทั้งหมด',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'ข่าวจากโลกของคนข้ามเพศ',
  'akt.prehratVideo': 'เล่นวิดีโอ',
  'akt.obrazekVClanku': 'รูปในบทความ',
  'akt.clanekNenalezen': 'ไม่พบบทความ',
  'akt.zpetNaAktuality': 'กลับไปที่ข่าวสาร',
  'akt.autor': (p) => `ผู้เขียน: ${p.kdo}`,
  'akt.osobniPribeh': 'เรื่องราวส่วนตัว',
  'akt.upravitClanek': 'แก้ไขบทความ',
  'akt.komentare': (p) => `ความคิดเห็น (${p.pocet})`,
  'akt.zadneKomentare': 'ยังไม่มีความคิดเห็น เป็นคนแรกสิ',
  'akt.pridatKomentar': 'เพิ่มความคิดเห็น…',
  'akt.proKomentovaniOverte': 'ยืนยันอีเมลเพื่อแสดงความคิดเห็น',
  'akt.profil': 'โปรไฟล์',
  'akt.prihlasteSeProKomentovani': 'เข้าสู่ระบบเพื่อแสดงความคิดเห็น',
  'akt.upravteObsah': 'แก้ไขเนื้อหาของบทความนี้',
  'akt.nadpisP': 'หัวข้อ *',
  'akt.nadpis': 'หัวข้อ',
  'akt.obsahP': 'เนื้อหา *',
  'akt.textClanku': 'เนื้อหาบทความ…',
  'akt.obrazekUrlNeboSoubor': 'รูป (ที่อยู่หรือไฟล์)',
  'akt.videoUrlNeboSoubor': 'วิดีโอ (ที่อยู่หรือไฟล์)',
  'akt.ukladam': 'กำลังบันทึก…',
  'akt.novaAktualita': 'ข่าวใหม่',
  'akt.sdiletPribeh': 'แบ่งปันเรื่องราว',
  'akt.vytvoritAktualitu': 'เขียนข่าว',
  'akt.sdiletZkusenost': 'แบ่งปันประสบการณ์',
  'akt.napisteAktualitu': 'เขียนข่าวใหม่ให้ชุมชน',
  'akt.podelteSe': 'แบ่งปันประสบการณ์ของคุณกับชุมชน',
  'akt.obrazek': 'รูปภาพ',
  'akt.nahratObrazek': 'อัปโหลดรูป…',
  'akt.nahratVideo': 'อัปโหลดวิดีโอ…',
  'akt.neboUrl': 'หรือที่อยู่:',
  'akt.textAktuality': 'เนื้อหาข่าว…',
  'akt.sdilejtePribeh': 'แบ่งปันเรื่องราวหรือประสบการณ์ของคุณกับชุมชน…',
  'akt.nahravam': 'กำลังอัปโหลด…',
  'akt.publikovat': 'เผยแพร่',
  'akt.zkusenostiTucne': 'ประสบการณ์ส่วนตัวของคนในชุมชน',
  'akt.zkusenostiPopis': 'ส่วนนี้มีไว้แบ่งปันประสบการณ์ชีวิตและเรื่องราว โพสต์อาจมีข้อความ รูป หรือวิดีโอ',
  'akt.sdiletSvujPribeh': 'แบ่งปันเรื่องราวของฉัน',
  'akt.zadneAktuality': 'ไม่มีข่าว',
  'akt.zadneVKategorii': 'หมวดหมู่นี้ยังไม่มีอะไร',
  'akt.publikovan': 'เผยแพร่โพสต์แล้ว',
  'akt.chybaPublikovat': 'เผยแพร่ไม่สำเร็จ',
  'akt.opravduSmazat': 'ลบโพสต์นี้?',
  'akt.chyba': 'มีบางอย่างผิดพลาด',
  'akt.chybaKomentar': 'เพิ่มความคิดเห็นไม่สำเร็จ',
  'akt.chybaSmazatKomentar': 'ลบความคิดเห็นไม่สำเร็จ',
  'akt.aktualizovan': 'อัปเดตโพสต์แล้ว',
  'obecne.smazat': 'ลบ',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'ฉันกำลังคิดเรื่องการข้ามเพศ',
  'faze.thinking.popis': 'ฉันกำลังหาว่าฉันเป็นใครและเส้นทางไหนคือของฉัน',
  'faze.research': 'ฉันกำลังหาข้อมูล',
  'faze.research.popis': 'ฉันอ่าน ถาม หาแหล่งข้อมูลและหาชุมชน',
  'faze.therapist': 'พบนักบำบัดครั้งแรก',
  'faze.therapist.popis': 'ฉันคุยเรื่องเส้นทางของฉันกับผู้เชี่ยวชาญ',
  'faze.hormones': 'การใช้ฮอร์โมน',
  'faze.hormones.popis': 'ฉันกำลังเริ่มหรือใช้ฮอร์โมนต่อเนื่อง',
  'faze.documents': 'การเปลี่ยนเอกสาร',
  'faze.documents.popis': 'ฉันกำลังดำเนินการเปลี่ยนชื่อหรือเพศตามกฎหมาย',
  'faze.cosmetic': 'รูปลักษณ์และการดูแลตัวเอง',
  'faze.cosmetic.popis': 'ฉันดูแลรูปลักษณ์ของตัวเอง – ผม แต่งหน้า สไตล์',
  'faze.surgery-thinking': 'ฉันกำลังพิจารณาการผ่าตัด',
  'faze.surgery-thinking.popis': 'ฉันกำลังชั่งใจเรื่องทางเลือกในการผ่าตัด',
  'faze.surgery': 'หลังการผ่าตัด',
  'faze.surgery.popis': 'ฉันผ่านการผ่าตัดมาแล้วหนึ่งครั้งหรือมากกว่า',
  'faze.stable': 'ระยะที่มั่นคง',
  'faze.stable.popis': 'ฉันอยู่ในจุดที่อยากอยู่ และใช้ชีวิตของตัวเอง',
  'faze.individual': 'เส้นทางของฉันเอง',
  'faze.individual.popis': 'เส้นทางของฉันไม่เข้ากรอบไหนเลย – และแบบนั้นก็ดีแล้ว',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'ที่นี่คือที่ที่เราแบ่งปันเรื่องราวกัน',
  'zk.pribehNenalezen': 'ไม่พบเรื่องราว',
  'zk.zpetNaPribehy': 'กลับไปที่เรื่องราว',
  'zk.komunita': 'ชุมชน',
  'zk.pribeh': 'เรื่องราว',
  'zk.upravitPribeh': 'แก้ไขเรื่องราว',
  'zk.upravtePribeh': 'แก้ไขเรื่องราวที่คุณแบ่งปัน',
  'zk.textPribehu': 'เนื้อหาเรื่องราว…',
  'zk.fazeTranzice': 'ระยะการข้ามเพศ',
  'zk.neuvadet': 'ไม่ระบุ',
  'zk.ukazeSeLidem': 'เรื่องราวจะแสดงให้คนที่อ่านคู่มือของระยะนั้นเห็น',
  'zk.sdiletPribeh': 'แบ่งปันเรื่องราว',
  'zk.overEmail': 'ยืนยันอีเมลเพื่อแบ่งปันเรื่องราว',
  'zk.zadnePribehy': 'ยังไม่มีเรื่องราว เป็นคนแรกสิ',
  'zk.nazevPribehu': 'ชื่อเรื่องราวของคุณ…',
  'zk.pribehP': 'เรื่องราว *',
  'zk.sdilejteZkusenost': 'แบ่งปันประสบการณ์ของคุณกับชุมชน…',
  'zk.chybaNacist': 'โหลดเรื่องราวไม่สำเร็จ',
  'zk.vyplnteNadpis': 'กรอกหัวข้อและเนื้อหา',
  'zk.spatnyOdkaz': 'ลิงก์รูปต้องขึ้นต้นด้วย http://, https:// หรือ /',
  'zk.sdilen': 'แบ่งปันเรื่องราวแล้ว',
  'zk.chybaSdilet': 'แบ่งปันไม่สำเร็จ',
  'zk.opravduSmazat': 'ลบเรื่องราวนี้?',
  'zk.smazan': 'ลบเรื่องราวแล้ว',
  'zk.aktualizovan': 'อัปเดตเรื่องราวแล้ว',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'อีเมลของคุณยังไม่ได้ยืนยัน โปรดยืนยัน',
  'ram.odesilam': 'กำลังส่ง…',
  'ram.znovuOdeslat': 'ส่งอีกครั้ง',
  'ram.chceteUpozorneni': 'อยากได้รับแจ้งเตือนเมื่อมีข้อความใหม่ไหม?',
  'ram.tedNe': 'ไว้ก่อน',
  'ram.paticka': '© 2026 Bloom – พื้นที่ส่วนตัวสำหรับชุมชนคนข้ามเพศ',
  'ram.zasadyKomunity': 'หลักปฏิบัติของชุมชน',
  'ram.prekladNeovereny': 'คำแปลนี้ยังไม่มีคนที่พูดภาษานี้อ่านทบทวน ถ้ามีอะไรฟังดูไม่ถูก บอกเราได้',
  'ram.nahlasitProblem': 'แจ้งปัญหา',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'ผู้ดูแล',
  'ot.overenyPravnik': 'นักกฎหมายที่ยืนยันแล้ว',
  'ot.overenyOdbornik': 'ผู้เชี่ยวชาญที่ยืนยันแล้ว',
  'ot.odznakJinaZeme': (p) => `เครื่องหมายนี้ใช้ได้เฉพาะกับ: ${p.zeme}`,
  'ot.otazkyKomunity': 'คำถามของชุมชน',
  'ot.pridatOtazku': 'เพิ่มคำถาม',
  'ot.novaOtazka': 'คำถามใหม่',
  'ot.naCoSeZeptat': 'คุณอยากถามอะไร?',
  'ot.otazkaSeZobrazi': 'คำถามของคุณจะแสดงให้คนอื่นในชุมชนเห็น และพวกเขาตอบได้',
  'ot.otazkaP': 'คำถาม *',
  'ot.oblastTema': 'ด้าน / หัวข้อ',
  'ot.vseObecna': 'อะไรก็ได้ (คำถามทั่วไป)',
  'ot.odeslatOtazku': 'ส่งคำถาม',
  'ot.overEmail': 'ยืนยันอีเมลเพื่อถามคำถาม',
  'ot.zadneOtazky': 'ยังไม่มีคำถาม เป็นคนแรกสิ',
  'ot.hlasu': () => 'โหวต',
  'ot.odpovedi': () => 'คำตอบ',
  'ot.zadneOdpovedi': 'ยังไม่มีคำตอบ',
  'ot.napisteOdpoved': 'เขียนคำตอบ…',
  'ot.jenPravnici': 'คำถามในหมวดความช่วยเหลือทางกฎหมายตอบโดยนักกฎหมายที่ยืนยันแล้วและผู้ดูแล',
  'ot.smazatOtazku': 'ลบคำถามนี้?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'ข้อเสนอและคำขอ',
  'cp.zadneNabidky': 'ไม่มีข้อเสนอ',
  'cp.napsatZpravu': 'เขียนข้อความ',
  'cp.nahlasitUzivatele': 'รายงานคนนี้',
  'cp.nahlasitKoho': (p) => `รายงาน: ${p.kdo}`,
  'cp.popisteDuvod': 'อธิบายว่าทำไมคุณจึงรายงาน ผู้ดูแลจะเห็นรายงานนี้',
  'cp.zustaneteAnonymni': 'ผู้ดูแลเป็นผู้รับรายงาน คุณยังไม่เปิดเผยตัว',
  'cp.duvodP': 'เหตุผล *',
  'cp.vybertDuvod': 'เลือกเหตุผล…',
  'cp.nevhodneChovani': 'พฤติกรรมไม่เหมาะสม',
  'cp.falesnyProfil': 'โปรไฟล์ปลอม',
  'cp.jinyProblem': 'ปัญหาอื่น',
  'cp.popisVolitelny': 'คำอธิบาย',
  'cp.volitelny': '(ไม่บังคับ)',
  'cp.popisteSituaci': 'อธิบายสถานการณ์ให้ละเอียดขึ้น…',
  'cp.odeslatNahlaseni': 'ส่งรายงาน',
  'cp.vyberteDuvodChyba': 'เลือกเหตุผลของการรายงาน',
  'cp.nahlaseniOdeslano': 'ส่งรายงานถึงผู้ดูแลแล้ว',
  'cp.chybaNahlaseni': 'ส่งรายงานไม่สำเร็จ',
  'gal.chranenoHeslem': 'ป้องกันด้วยรหัสผ่าน',
  'gal.soukromi': 'ความเป็นส่วนตัว',
  'gal.nahravam': 'กำลังอัปโหลด…',
  'gal.pridatFotku': 'เพิ่มรูป',
  'gal.nastaveniSoukromi': 'ความเป็นส่วนตัวของแกลเลอรี',
  'gal.verejna': 'สาธารณะ',
  'gal.chranenaHeslem': 'ป้องกันด้วยรหัสผ่าน',
  'gal.nastaveniUlozeno': 'บันทึกการตั้งค่าแกลเลอรีแล้ว',
  'gal.jeChranena': 'แกลเลอรีนี้ป้องกันด้วยรหัสผ่าน',
  'gal.zadneFotky': 'ยังไม่มีรูป เพิ่มรูปแรกเลย',
  'gal.otagovat': 'แท็กคน',
  'gal.hledatUzivatele': 'ค้นหาคน…',
  'gal.odemcena': 'ปลดล็อกแกลเลอรีแล้ว',
  'gal.spatneHeslo': 'รหัสผ่านแกลเลอรีไม่ถูกต้อง',
  'gal.fotkaNahrana': 'อัปโหลดรูปแล้ว',
  'gal.chybaNahrat': 'อัปโหลดรูปไม่สำเร็จ',
  'gal.fotkaSmazana': 'ลบรูปแล้ว',
  'gal.jizOtagovan': 'คนนี้ถูกแท็กไปแล้ว',
  'gal.otagovan': (p) => `แท็กแล้ว: ${p.kdo}`,
  'gal.chybaTag': 'เพิ่มแท็กไม่สำเร็จ',
  'gal.soukromiGalerie': 'ความเป็นส่วนตัวของแกลเลอรี',
  'gal.verejnaGalerie': 'แกลเลอรีสาธารณะ',

  'ram.povolit': 'อนุญาต',
  'ram.oProjektu': 'เกี่ยวกับโครงการ',
  'ram.kontakt': 'ติดต่อ',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'แผนที่โลก – คลิกที่ประเทศเพื่อเปิด',
  'mapa.priblizit': 'ซูมเข้า',
  'mapa.oddalit': 'ซูมออก',
  'mapa.celySvet': 'กลับไปทั้งโลก',
  'mapa.chybaNacteni': 'โหลดแผนที่ไม่สำเร็จ',
  'mapa.chybaZkusteSeznam': 'โหลดแผนที่ไม่สำเร็จ ลองใช้รายชื่อประเทศด้านล่าง',
  'mapa.teprveRoste': 'Bloom เพิ่งเริ่มต้นที่นี่',
  'mapa.napovedaDotyk': 'ลากเพื่อเลื่อนแผนที่ ซูมด้วยสองนิ้ว แตะสองครั้ง หรือใช้ปุ่ม ไม่จำเป็นต้องใช้ก็ได้ — ด้านล่างมีช่องค้นหาและรายชื่อประเทศทั้งหมด',
  'obsah.specialists': () => 'ผู้เชี่ยวชาญ',
  'obsah.organizations': () => 'องค์กร',
  'obsah.events': () => 'กิจกรรม',
  'obsah.pageants': () => 'การประกวด',
  'obsah.resources': () => 'แหล่งข้อมูล',
  'obsah.zaznamu': (p) => `${p.pocet} รายการ`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'บ้านของคุณอยู่ที่ไหน?',
  'domov.popis': 'Bloom จะได้แสดงสิ่งที่อยู่ใกล้คุณ คุณดูประเทศไหนก็ได้ — นั่นไม่เปลี่ยน '
      + 'ประเทศที่คุณอยู่ ข้อมูลนี้ไม่ถูกเผยแพร่ที่ไหน และเปลี่ยนเมื่อไรก็ได้',
  'domov.preskocit': 'ข้าม',
  'domov.najitZemi': 'ค้นหาประเทศ…',
  'domov.nicNeodpovida': 'ไม่มีอะไรตรงกัน ลองค้นแบบอื่น',
  'domov.klikniDoMapy': 'คุณจะคลิกที่ประเทศบนแผนที่ด้านบนเลยก็ได้',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'โพสต์',
  'typ.users': 'คน',
  'typ.specialists': 'ผู้เชี่ยวชาญ',
  'typ.services': 'ข้อเสนอ',
  'typ.articles': 'ความช่วยเหลือทางกฎหมาย',
  'typ.questions': 'คำถามของชุมชน',
  'typ.reviews': 'รีวิวผู้เชี่ยวชาญ',
  'nav.emailNeoveren': 'อีเมลยังไม่ยืนยัน',
  'nav.neovereny': 'ยังไม่ยืนยัน',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'บางอย่างใช้ไม่ได้',
  'chyba.navrh': 'ข้อเสนอให้ปรับปรุง',
  'chyba.bezpecnost': 'ปัญหาด้านความปลอดภัย',
  'chyba.jiny': 'เรื่องอื่น',
  'chyba.vyberteTyp': 'โปรดเลือกประเภทของปัญหา',
  'chyba.popisteProsim': 'โปรดอธิบายปัญหา',
  'chyba.odeslano': 'ส่งรายงานแล้ว ขอบคุณ!',
  'chyba.chybaOdeslat': 'ส่งรายงานไม่สำเร็จ',
  'chyba.napisteNam': 'เล่าให้เราฟังว่าเกิดอะไรขึ้น — จะช่วยให้เราแก้ได้',
  'chyba.typProblemu': 'ประเภทของปัญหา',
  'chyba.popisProblemu': 'เกิดอะไรขึ้น',
  'chyba.popisPriklad': 'เล่าว่าเกิดอะไรขึ้น คุณคาดหวังอะไร และเกิดอะไรขึ้นแทน…',
  'chyba.priloha': 'เราแนบให้อัตโนมัติ: หน้าปัจจุบัน เวลา และข้อมูลเกี่ยวกับเบราว์เซอร์ของคุณ',
  'chyba.odeslatHlaseni': 'ส่งรายงาน',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'เขียนเนื้อหา…',
  'ed.tucne': 'ตัวหนา (Ctrl+B)',
  'ed.kurziva': 'ตัวเอียง (Ctrl+I)',
  'ed.odrazky': 'รายการแบบจุด',
  'ed.vlozitOdkaz': 'แทรกลิงก์',
  'ed.vlozitTabulku': 'แทรกตาราง',
  'ed.radky': 'แถว',
  'ed.sloupce': 'คอลัมน์',
  'ed.vlozit': 'แทรก',
  'ed.barva.cerna': 'ดำ',
  'ed.barva.seda': 'เทา',
  'ed.barva.fialova': 'ม่วง',
  'ed.barva.ruzova': 'ชมพู',
  'ed.barva.modra': 'น้ำเงิน',
  'ed.barva.zelena': 'เขียว',
  'ed.barva.cervena': 'แดง',
  'ed.barva.oranzova': 'ส้ม',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'ลิงก์ยืนยันนี้ใช้ไม่ได้',
  'over.hotovo': 'อีเมลของคุณได้รับการยืนยันแล้ว',
  'over.odkazVyprsel': 'ลิงก์ยืนยันใช้ไม่ได้หรือหมดอายุแล้ว',
  'over.overuji': 'กำลังยืนยันอีเมล…',
  'over.cekejte': 'โปรดรอสักครู่',
  'over.overen': 'ยืนยันอีเมลแล้ว',
  'over.plnyPristup': 'ตอนนี้คุณเข้าถึงทุกอย่างใน Bloom ได้เต็มที่',
  'over.prejitNaBloom': 'ไปที่ Bloom',
  'over.selhalo': 'การยืนยันไม่สำเร็จ',
  'over.zpetNaPrihlaseni': 'กลับไปหน้าเข้าสู่ระบบ',
  'oauth.ucetNenalezen': 'ไม่พบบัญชี',
  'oauth.neexistujeGoogle': 'บัญชี Google นี้ยังไม่มีบัญชี Bloom โปรดสมัครก่อน',
  'oauth.neexistujeFacebook': 'บัญชี Facebook นี้ยังไม่มีบัญชี Bloom โปรดสมัครก่อน',
  'oauth.registrovatGoogle': 'สมัครด้วย Google',
  'oauth.registrovatFacebook': 'สมัครด้วย Facebook',
  'oauth.prihlasujiGoogle': 'กำลังเข้าสู่ระบบด้วย Google…',
  'oauth.prihlasujiFacebook': 'กำลังเข้าสู่ระบบด้วย Facebook…',
  'oauth.facebookSelhalo': 'เข้าสู่ระบบด้วย Facebook ไม่สำเร็จ',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'กำลังโหลด…',
  'obecne.nezadano': '— ไม่ได้ระบุ —',
  'obecne.neplatnaHodnota': 'ค่านี้ใช้ไม่ได้',
  'obecne.strankovani': 'การแบ่งหน้า',
  'navrh.doplnteNazev': 'โปรดกรอกชื่อ',
  'navrh.vyberteZemi': 'โปรดเลือกประเทศ',
  'navrh.doplnte': (p) => `โปรดกรอก: ${p.co}`,
  'kat.overenoZaznam': 'ตรวจสอบแล้วว่ารายการตรงกับความจริง',
  'kat.prihlaskyDo': (p) => `รับสมัครถึง ${p.datum}`,

  'up.odznakAdmin': 'ผู้ดูแล',

  'profil.zalozkaProfil': 'โปรไฟล์',
  'profil.zalozkaGalerie': 'แกลเลอรี',
  'pf.lokalita': 'สถานที่',

  'cesta.legendaBarev': 'คำอธิบายสี',

  'hled.pocetVysledku': (p) => `(${p.pocet} รายการ)`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'ผมบลอนด์ยาว',
  'avatar.fem-lavender': 'ผมสีม่วง',
  'avatar.fem-peach': 'ผมบ๊อบมีหน้าม้า',
  'avatar.fem-dark': 'ผมดำยาว',
  'avatar.fem-straight': 'ผมสีแดง',
  'avatar.fem-ponytail': 'ผมหางม้า',
  'avatar.masc-blue': 'ผมบลอนด์สั้น',
  'avatar.masc-teal': 'ผมยุ่ง',
  'avatar.masc-gray': 'ผมหงอก',
  'avatar.masc-short': 'ผมเกรียน',
  'avatar.nb-mint': 'ผมสีเขียวมิ้นต์',
  'avatar.nb-lilac': 'มวยผมสูง',
  'avatar.nb-curly': 'ผมหยิกสั้น',
  'avatar.nb-sage': 'ผมยาวประบ่า',
  'avatar.nb-mohawk': 'ผมโมฮอว์ก',
  'avatar.nb-undercut': 'อันเดอร์คัต',
  'avatar.nb-shaved': 'โกนหัว',
  'avatar.nb-glasses': 'แว่นตา',
  'avatar.animal-cat': 'แมว',
  'avatar.animal-fox': 'จิ้งจอก',
  'avatar.animal-rabbit': 'กระต่าย',
  'avatar.sym-flower': 'ดอกไม้',
  'avatar.sym-butterfly': 'ผีเสื้อ',
  'avatar.sym-star': 'ดาว',
  'avatar.custom': 'อัปโหลดรูปของฉันเอง',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'เราออกจากระบบให้คุณหลังจากไม่มีการใช้งานสักพัก',
  'odhl.necinnostPopis': 'Bloom ไม่ปล่อยให้เข้าสู่ระบบค้างไว้เมื่อไม่มีใครอยู่',
  'odhl.zaChvili': 'อีกสักครู่เราจะออกจากระบบให้คุณ',
  'odhl.zaChviliPopis': 'แตะหน้าจอหรือแป้นพิมพ์เมื่อไรก็ได้ แล้วคุณจะยังอยู่ในระบบ',

  'reg.avatarSymboly': 'สัญลักษณ์',

  'avatar.fem-bun': 'มวยผม',
  'avatar.masc-navy': 'เคราเต็ม',
  'avatar.masc-brown': 'แสกข้าง',
  'avatar.masc-goatee': 'เคราแพะ',
  'avatar.nb-freckles': 'กระ',
  'avatar.animal-panda': 'แพนด้า',
  'avatar.animal-owl': 'นกฮูก',
  'avatar.sym-rainbow': 'สายรุ้ง',
  'avatar.sym-heart': 'หัวใจ',
  'avatar.sym-lotus': 'ดอกบัว (Bloom)',

  'reg.potvrditHeslo': 'ยืนยันรหัสผ่าน',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'สร้าง',
  'obecne.sdilet': 'แบ่งปัน',
  'obecne.opravneni': 'การอนุญาต',
  'obecne.pristupGalerie': 'เราต้องขอสิทธิ์เข้าถึงคลังภาพเพื่ออัปโหลดรูป',
  'obecne.vsechnyRegiony': 'ทุกภูมิภาค',
  'obecne.cesko': 'เช็กเกีย',
  'obecne.odbornici': 'ผู้เชี่ยวชาญ',
  'obecne.zadnaZprava': 'ยังไม่มีข้อความ',
  'ucet.vyplnteEmailHeslo': 'กรอกอีเมลและรหัสผ่าน',
  'ucet.spatneUdaje': 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
  'ucet.googleSelhalo': 'เข้าสู่ระบบด้วย Google ไม่สำเร็จ',
  'ucet.skrytHeslo': 'ซ่อนรหัสผ่าน',
  'ucet.emailOveren': 'ยืนยันอีเมลเรียบร้อยแล้ว',
  'ucet.emailPriklad': 'you@email.com',
  'ucet.overeniSelhalo': 'การยืนยันไม่สำเร็จ',
  'ucet.overeniSelhaloZnovu': 'การยืนยันไม่สำเร็จ กรุณาลองอีกครั้ง',
  'ucet.komunitniHesloPovinne': 'ต้องกรอกรหัสผ่านของชุมชน',
  'ucet.zadejteKomunitniHeslo': 'กรอกรหัสผ่านของชุมชน…',
  'ucet.komunitniHesloPopis': 'Bloom เป็นพื้นที่ส่วนตัว คนในชุมชนสามารถให้รหัสผ่านกับคุณได้',
  'ucet.prezdivkaMin3': 'ชื่อที่แสดงต้องมีอย่างน้อย 3 ตัวอักษร',
  'ucet.vyplntePrezdivku': 'กรอกชื่อที่แสดง',
  'ucet.vasePrezdivka': 'ชื่อที่แสดงของคุณ',
  'ucet.profilNeulozen': 'บันทึกโปรไฟล์ไม่สำเร็จ',
  'ucet.anoZrusitProfil': 'ใช่ ลบโปรไฟล์ของฉัน',
  'heslo.min8': 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร',
  'heslo.maleP': 'รหัสผ่านต้องมีตัวพิมพ์เล็ก',
  'heslo.velkeP': 'รหัสผ่านต้องมีตัวพิมพ์ใหญ่',
  'heslo.cislo': 'รหัสผ่านต้องมีตัวเลข',
  'heslo.specialni': 'รหัสผ่านต้องมีอักขระพิเศษ',
  'heslo.specialniPriklad': 'รหัสผ่านต้องมีอักขระพิเศษ (!@#$%)',
  'heslo.napoveda': 'อย่างน้อย 8 ตัว มีพิมพ์ใหญ่ ตัวเลข อักขระพิเศษ',
  'profil.oSobe': 'เล่าเกี่ยวกับตัวคุณสั้น ๆ…',
  'profil.zajmenaOna': 'เธอ',
  'profil.zajmenaJine': 'อื่น ๆ',
  'profil.doplnujiciText': 'ข้อความเพิ่มเติม (ไม่บังคับ)…',
  'profil.prikladOboru': 'เช่น ศัลยกรรมตกแต่ง กฎหมายครอบครัว…',
  'komunita.soukromiNadpis': 'เราปกป้องความเป็นส่วนตัว',
  'komunita.soukromiText': 'สิ่งที่แบ่งปันใน Bloom จะอยู่ใน Bloom',
  'komunita.podporaText': 'Bloom คือการสนับสนุนซึ่งกันและกัน',
  'komunita.neniObchod': 'Bloom ไม่ใช่แพลตฟอร์มการค้า',
  'komunita.zadneObtezovani': 'การคุกคามทุกรูปแบบไม่มีที่ใน Bloom',
  'komunita.oslovovani': 'เราเรียกทุกคนด้วยชื่อและคำสรรพนามที่เขาใช้',
  'komunita.jakakolivEtapa': 'ไม่ว่าคุณจะอยู่ช่วงไหนของเส้นทาง',
  'prav.kategZdravi': 'สุขภาพ',
  'prav.kategPravni': 'กฎหมาย',
  'prav.kategSocialni': 'สังคม',
  'ot.chybaOdpoved': 'ส่งคำตอบไม่สำเร็จ',
  'ot.chybaOtazka': 'เพิ่มคำถามไม่สำเร็จ',
  'zk.napisteKomentar': 'เขียนความคิดเห็น…',
  'zpr.chybaHlasova': 'อัปโหลดข้อความเสียงไม่สำเร็จ เซิร์ฟเวอร์:',
  'zpr.chybaObrazek': 'อัปโหลดรูปภาพไม่สำเร็จ เซิร์ฟเวอร์:',
  'pod.nabizim': 'ฉันเสนอ',
  'pod.coHledate': 'คุณกำลังมองหาอะไร (เช่น นวด ถ่ายภาพ…)',
  'pod.coNabizite': 'คุณเสนออะไร (เช่น ทำอาหาร ทำผม…)',
  'pod.lokalitaVolitelna': 'สถานที่ (ไม่บังคับ)',
  'pod.podrobnejsiPopis': 'รายละเอียดเพิ่มเติม *',
  'pod.vyplnteHledate': 'ระบุสิ่งที่คุณกำลังมองหา',
  'pod.vyplnteNabizite': 'ระบุสิ่งที่คุณเสนอ',
  'pod.vyplntePopis': 'เพิ่มคำอธิบาย',
  'pod.zadnePrispevky': 'คุณยังไม่มีโพสต์ สร้างข้อเสนอหรือคำขอได้เลย',
  'svet.vybratZemi': 'เลือกประเทศ',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'ตั้งคำถาม',
  'ot.nadpis': 'คำถามและคำตอบ',
  'zk.pridat': 'เพิ่มเรื่องราว',
  'zk.novy': 'เรื่องราวใหม่',
  'zk.smazat': 'ลบเรื่องราว',
  'zk.zadne': 'ยังไม่มีเรื่องราว มาเป็นคนแรกที่แบ่งปันกัน',
  'akt.zadne': 'ยังไม่มีข่าว',
  'nav.clanky': 'บทความ',
  'ucet.emailOdeslan': 'ส่งอีเมลแล้ว',
  'ucet.komunitniHeslo': 'รหัสผ่านของชุมชน',
  'ucet.nemateUcet': 'ยังไม่มีบัญชีใช่ไหม สมัครเลย',
  'ucet.muzetePrihlasit': 'ตอนนี้คุณเข้าสู่ระบบได้แล้ว',
  'ucet.zapomenutePopis': 'กรอกอีเมลแล้วเราจะส่งลิงก์สำหรับตั้งรหัสผ่านใหม่ให้',
  'profil.oMneVolitelne': 'เกี่ยวกับฉัน (ไม่บังคับ)',
  'profil.prezdivka': 'ชื่อที่แสดง',
  'profil.telefonVolitelne': 'โทรศัพท์ (ไม่บังคับ)',
  'cesta.poznamkaVolitelna': 'บันทึกส่วนตัว (ไม่บังคับ)',
  'okoli.vyberteLokalitu': 'เลือกสถานที่ด้านบน',
  'hled.nadpis': 'ค้นหา',
  'hled.popis': 'ค้นหาทั่วทั้งแอป — ผู้คน บทความ เรื่องราว รีวิว…',
  'hled.min2': 'พิมพ์อย่างน้อย 2 ตัวอักษรเพื่อค้นหา',
  'pod.vsechnySluzby': 'บริการทั้งหมด',
  'domu.clenoveKomunity': 'สมาชิกชุมชน',
  'zpr.zadneKonverzaceHledat': 'ยังไม่มีบทสนทนา ค้นหาใครสักคนด้านบน',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'เขา (ชาย)',
  'reg.zajmenaOni': 'เขา (ไม่ระบุเพศ)',
  'reg.zajmenaOno': 'มัน',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'ลบรูปภาพ',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'ตั้งรหัสผ่านสำหรับแกลเลอรี',
  'reg.min3znaky': 'อย่างน้อย 3 ตัวอักษร',
  'reg.zopakujteHeslo': 'กรอกรหัสผ่านอีกครั้ง',
  'hled.vBloom': 'ค้นหาใน Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'แก้ไขโปรไฟล์',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'เลือกภูมิภาค',
  'obecne.region': 'ภูมิภาค',
  'gal.heslemChranena': 'ป้องกันด้วยรหัสผ่าน',
  'gal.hesloGalerie': 'รหัสผ่านแกลเลอรี',
  'reset.nastavitHeslo': 'ตั้งรหัสผ่าน',
  'reset.hesloObnoveno': 'ตั้งรหัสผ่านใหม่เรียบร้อยแล้ว',
  'profil.nenalezen': 'ไม่พบโปรไฟล์',
  'obecne.nebo': 'หรือ',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'เปิดแอปรหัสยืนยันแล้วกรอกตัวเลขหกหลักของ Bloom หรือจะใช้รหัสสำรองแทนก็ได้',
  'auth.sifrovaniNapoveda': 'หากคุณเปิดการเข้ารหัสข้อความไว้บนเว็บ แอปยังเข้าสู่ระบบบัญชีนั้นไม่ได้ กรุณาใช้ bloomapp.cz ในเบราว์เซอร์',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'แสดงรหัสผ่าน',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'ลบรูปนี้ไหม',
  'dvf.zadejteKod': 'กรอกรหัสจากแอปของคุณ',
  'sif.odemknoutAplikaci': 'ปลดล็อกแอป',
  'profil.odeslatZnovu': 'ส่งอีกครั้ง',
};

export default th;
